// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328a745%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23000%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23000%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#iris-recommend {
  display: flex;
  justify-content: center;
  position: relative;
}

.iris-recommend {
  margin: 1px auto;
}

#iris-recommend-ui #carousel_container {
  overflow: visible;
}

/* body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
} */
#iris-recommend-ui .iiris-btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  #iris-recommend-ui .iiris-btn {
    transition: none;
  }
}
#iris-recommend-ui .iiris-btn:hover {
  color: #212529;
  text-decoration: none;
}
#iris-recommend-ui .iiris-btn.focus,
#iris-recommend-ui .iiris-btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
#iris-recommend-ui .iiris-btn.disabled,
#iris-recommend-ui .iiris-btn:disabled {
  opacity: 0.65;
}
#iris-recommend-ui .iiris-btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
#iris-recommend-ui a.iiris-btn.disabled,
#iris-recommend-ui fieldset:disabled a.iiris-btn {
  pointer-events: none;
}
#iris-recommend-ui .iiris-btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
#iris-recommend-ui .iiris-btn-primary:hover {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
}
#iris-recommend-ui .iiris-btn-primary.focus,
#iris-recommend-ui .iiris-btn-primary:focus {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}
#iris-recommend-ui .iiris-btn-primary.disabled,
#iris-recommend-ui .iiris-btn-primary:disabled {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
#iris-recommend-ui .iiris-btn-primary:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-primary:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #0062cc;
  border-color: #005cbf;
}
#iris-recommend-ui
  .iiris-btn-primary:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-primary:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}
#iris-recommend-ui .iiris-btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
#iris-recommend-ui .iiris-btn-secondary:hover {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}
#iris-recommend-ui .iiris-btn-secondary.focus,
#iris-recommend-ui .iiris-btn-secondary:focus {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}
#iris-recommend-ui .iiris-btn-secondary.disabled,
#iris-recommend-ui .iiris-btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
#iris-recommend-ui .iiris-btn-secondary:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-secondary:not(:disabled):not(.disabled):active,
.show > .iiris-btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}
#iris-recommend-ui
  .iiris-btn-secondary:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-secondary:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}
#iris-recommend-ui .iiris-btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
#iris-recommend-ui .iiris-btn-success:hover {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
}
#iris-recommend-ui .iiris-btn-success.focus,
#iris-recommend-ui .iiris-btn-success:focus {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}
#iris-recommend-ui .iiris-btn-success.disabled,
#iris-recommend-ui .iiris-btn-success:disabled {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
#iris-recommend-ui .iiris-btn-success:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-success:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-success.dropdown-toggle {
  color: #fff;
  background-color: #1e7e34;
  border-color: #1c7430;
}
#iris-recommend-ui
  .iiris-btn-success:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-success:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}
#iris-recommend-ui .iiris-btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
#iris-recommend-ui .iiris-btn-info:hover {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
}
#iris-recommend-ui .iiris-btn-info.focus,
#iris-recommend-ui .iiris-btn-info:focus {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
}
#iris-recommend-ui .iiris-btn-info.disabled,
#iris-recommend-ui .iiris-btn-info:disabled {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
#iris-recommend-ui .iiris-btn-info:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-info:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-info.dropdown-toggle {
  color: #fff;
  background-color: #117a8b;
  border-color: #10707f;
}
#iris-recommend-ui .iiris-btn-info:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui .iiris-btn-info:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
}
#iris-recommend-ui .iiris-btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
#iris-recommend-ui .iiris-btn-warning:hover {
  color: #212529;
  background-color: #e0a800;
  border-color: #d39e00;
}
#iris-recommend-ui .iiris-btn-warning.focus,
#iris-recommend-ui .iiris-btn-warning:focus {
  color: #212529;
  background-color: #e0a800;
  border-color: #d39e00;
  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
}
#iris-recommend-ui .iiris-btn-warning.disabled,
#iris-recommend-ui .iiris-btn-warning:disabled {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
#iris-recommend-ui .iiris-btn-warning:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-warning:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-warning.dropdown-toggle {
  color: #212529;
  background-color: #d39e00;
  border-color: #c69500;
}
#iris-recommend-ui
  .iiris-btn-warning:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-warning:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
}
#iris-recommend-ui .iiris-btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
#iris-recommend-ui .iiris-btn-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}
#iris-recommend-ui .iiris-btn-danger.focus,
#iris-recommend-ui .iiris-btn-danger:focus {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}
#iris-recommend-ui .iiris-btn-danger.disabled,
#iris-recommend-ui .iiris-btn-danger:disabled {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
#iris-recommend-ui .iiris-btn-danger:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-danger:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #bd2130;
  border-color: #b21f2d;
}
#iris-recommend-ui .iiris-btn-danger:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui .iiris-btn-danger:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}
#iris-recommend-ui .iiris-btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
#iris-recommend-ui .iiris-btn-light:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}
#iris-recommend-ui .iiris-btn-light.focus,
#iris-recommend-ui .iiris-btn-light:focus {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}
#iris-recommend-ui .iiris-btn-light.disabled,
#iris-recommend-ui .iiris-btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
#iris-recommend-ui .iiris-btn-light:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-light:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-light.dropdown-toggle {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
}
#iris-recommend-ui .iiris-btn-light:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui .iiris-btn-light:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}
#iris-recommend-ui .iiris-btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
#iris-recommend-ui .iiris-btn-dark:hover {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
}
#iris-recommend-ui .iiris-btn-dark.focus,
#iris-recommend-ui .iiris-btn-dark:focus {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}
#iris-recommend-ui .iiris-btn-dark.disabled,
#iris-recommend-ui .iiris-btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
#iris-recommend-ui .iiris-btn-dark:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-dark:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #1d2124;
  border-color: #171a1d;
}
#iris-recommend-ui .iiris-btn-dark:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui .iiris-btn-dark:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}
#iris-recommend-ui .iiris-btn-outline-primary:hover {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
#iris-recommend-ui .iiris-btn-outline-primary.focus,
#iris-recommend-ui .iiris-btn-outline-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-primary.disabled,
#iris-recommend-ui .iiris-btn-outline-primary:disabled {
  color: #007bff;
  background-color: transparent;
}
#iris-recommend-ui
  .iiris-btn-outline-primary:not(:disabled):not(.disabled).active,
#iris-recommend-ui
  .iiris-btn-outline-primary:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
#iris-recommend-ui
  .iiris-btn-outline-primary:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-outline-primary:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
#iris-recommend-ui .iiris-btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
#iris-recommend-ui .iiris-btn-outline-secondary.focus,
#iris-recommend-ui .iiris-btn-outline-secondary:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-secondary.disabled,
#iris-recommend-ui .iiris-btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
#iris-recommend-ui
  .iiris-btn-outline-secondary:not(:disabled):not(.disabled).active,
#iris-recommend-ui
  .iiris-btn-outline-secondary:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
#iris-recommend-ui
  .iiris-btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-success {
  color: #28a745;
  border-color: #28a745;
}
#iris-recommend-ui .iiris-btn-outline-success:hover {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
#iris-recommend-ui .iiris-btn-outline-success.focus,
#iris-recommend-ui .iiris-btn-outline-success:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-success.disabled,
#iris-recommend-ui .iiris-btn-outline-success:disabled {
  color: #28a745;
  background-color: transparent;
}
#iris-recommend-ui
  .iiris-btn-outline-success:not(:disabled):not(.disabled).active,
#iris-recommend-ui
  .iiris-btn-outline-success:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
#iris-recommend-ui
  .iiris-btn-outline-success:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-outline-success:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8;
}
#iris-recommend-ui .iiris-btn-outline-info:hover {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
#iris-recommend-ui .iiris-btn-outline-info.focus,
#iris-recommend-ui .iiris-btn-outline-info:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-info.disabled,
#iris-recommend-ui .iiris-btn-outline-info:disabled {
  color: #17a2b8;
  background-color: transparent;
}
#iris-recommend-ui .iiris-btn-outline-info:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-outline-info:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
#iris-recommend-ui
  .iiris-btn-outline-info:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-outline-info:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}
#iris-recommend-ui .iiris-btn-outline-warning:hover {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
#iris-recommend-ui .iiris-btn-outline-warning.focus,
#iris-recommend-ui .iiris-btn-outline-warning:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-warning.disabled,
#iris-recommend-ui .iiris-btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}
#iris-recommend-ui
  .iiris-btn-outline-warning:not(:disabled):not(.disabled).active,
#iris-recommend-ui
  .iiris-btn-outline-warning:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
#iris-recommend-ui
  .iiris-btn-outline-warning:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-outline-warning:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}
#iris-recommend-ui .iiris-btn-outline-danger:hover {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
#iris-recommend-ui .iiris-btn-outline-danger.focus,
#iris-recommend-ui .iiris-btn-outline-danger:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-danger.disabled,
#iris-recommend-ui .iiris-btn-outline-danger:disabled {
  color: #dc3545;
  background-color: transparent;
}
#iris-recommend-ui
  .iiris-btn-outline-danger:not(:disabled):not(.disabled).active,
#iris-recommend-ui
  .iiris-btn-outline-danger:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
#iris-recommend-ui
  .iiris-btn-outline-danger:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-outline-danger:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
#iris-recommend-ui .iiris-btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
#iris-recommend-ui .iiris-btn-outline-light.focus,
#iris-recommend-ui .iiris-btn-outline-light:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-light.disabled,
#iris-recommend-ui .iiris-btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}
#iris-recommend-ui
  .iiris-btn-outline-light:not(:disabled):not(.disabled).active,
#iris-recommend-ui
  .iiris-btn-outline-light:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
#iris-recommend-ui
  .iiris-btn-outline-light:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-outline-light:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
#iris-recommend-ui .iiris-btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
#iris-recommend-ui .iiris-btn-outline-dark.focus,
#iris-recommend-ui .iiris-btn-outline-dark:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
#iris-recommend-ui .iiris-btn-outline-dark.disabled,
#iris-recommend-ui .iiris-btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
#iris-recommend-ui .iiris-btn-outline-dark:not(:disabled):not(.disabled).active,
#iris-recommend-ui .iiris-btn-outline-dark:not(:disabled):not(.disabled):active,
#iris-recommend-ui .show > .iiris-btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
#iris-recommend-ui
  .iiris-btn-outline-dark:not(:disabled):not(.disabled).active:focus,
#iris-recommend-ui
  .iiris-btn-outline-dark:not(:disabled):not(.disabled):active:focus,
#iris-recommend-ui .show > .iiris-btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
#iris-recommend-ui .iiris-btn-link {
  font-weight: 400;
  color: #007bff;
  text-decoration: none;
}
#iris-recommend-ui .iiris-btn-link:hover {
  color: #0056b3;
  text-decoration: underline;
}
#iris-recommend-ui .iiris-btn-link.focus,
#iris-recommend-ui .iiris-btn-link:focus {
  text-decoration: underline;
}
#iris-recommend-ui .iiris-btn-link.disabled,
#iris-recommend-ui .iiris-btn-link:disabled {
  color: #6c757d;
  pointer-events: none;
}
#iris-recommend-ui .iiris-btn-group-lg > .iiris-btn,
#iris-recommend-ui .iiris-btn-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
#iris-recommend-ui .iiris-btn-group-sm > .iiris-btn,
#iris-recommend-ui .iiris-btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
#iris-recommend-ui .iiris-btn-block {
  display: block;
  width: 100%;
}
#iris-recommend-ui .iiris-btn-block + .iiris-btn-block {
  margin-top: 0.5rem;
}
#iris-recommend-ui input[type="button"].iiris-btn-block,
#iris-recommend-ui input[type="reset"].iiris-btn-block,
#iris-recommend-ui input[type="submit"].iiris-iiris-btn-block {
  width: 100%;
}
#iris-recommend-ui .iiris-btn-block {
  display: block;
  width: 100%;
}
#iris-recommend-ui .iiris-btn-block + .iiris-btn-block {
  margin-top: 0.5rem;
}
#iris-recommend-ui input[type="button"].iiris-btn-block,
#iris-recommend-ui input[type="reset"].iiris-btn-block,
#iris-recommend-ui input[type="submit"].iiris-btn-block {
  width: 100%;
}
#iris-recommend-ui .iiris-text-center {
  text-align: center !important;
}
#iris-recommend-ui .iiris-input-group {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
}
#iris-recommend-ui .iiris-input-group > .custom-file,
#iris-recommend-ui .iiris-input-group > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group > .iiris-form-control,
#iris-recommend-ui .iiris-input-group > .form-control-plaintext {
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
#iris-recommend-ui .iiris-input-group > .custom-file + .custom-file,
#iris-recommend-ui .iiris-input-group > .custom-file + .iiris-custom-select,
#iris-recommend-ui .iiris-input-group > .custom-file + .iiris-form-control,
#iris-recommend-ui .iiris-input-group > .iiris-custom-select + .custom-file,
#iris-recommend-ui
  .iiris-input-group
  > .iiris-custom-select
  + .iiris-custom-select,
#iris-recommend-ui
  .iiris-input-group
  > .iiris-custom-select
  + .iiris-form-control,
#iris-recommend-ui .iiris-input-group > .form-control + .custom-file,
#iris-recommend-ui .iiris-input-group > .form-control + .iiris-custom-select,
#iris-recommend-ui .iiris-input-group > .form-control + .form-control,
#iris-recommend-ui .iiris-input-group > .form-control-plaintext + .custom-file,
#iris-recommend-ui
  .iiris-input-group
  > .form-control-plaintext
  + .iiris-custom-select,
#iris-recommend-ui
  .iiris-input-group
  > .form-control-plaintext
  + .form-control {
  margin-left: -1px;
}
#iris-recommend-ui
  .iiris-input-group
  > .custom-file
  .custom-file-input:focus
  ~ .custom-file-label,
#iris-recommend-ui .iiris-input-group > .iiris-custom-select:focus,
#iris-recommend-ui .iiris-input-group > .iiris-form-control:focus {
  z-index: 3;
}
#iris-recommend-ui .iiris-input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
#iris-recommend-ui .iiris-input-group > .iiris-custom-select:not(:last-child),
#iris-recommend-ui .iiris-input-group > .iiris-form-control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
#iris-recommend-ui .iiris-input-group > .iiris-custom-select:not(:first-child),
#iris-recommend-ui .iiris-input-group > .iiris-form-control:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
#iris-recommend-ui .iiris-input-group > .custom-file {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}
#iris-recommend-ui
  .iiris-input-group
  > .custom-file:not(:last-child)
  .custom-file-label,
#iris-recommend-ui
  .iiris-input-group
  > .custom-file:not(:last-child)
  .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
#iris-recommend-ui
  .iiris-input-group
  > .custom-file:not(:first-child)
  .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
#iris-recommend-ui .iiris-input-group-append,
#iris-recommend-ui .iiris-input-group-prepend {
  display: -ms-flexbox;
  display: flex;
}
#iris-recommend-ui .iiris-input-group-append .btn,
#iris-recommend-ui .iiris-input-group-prepend .btn {
  position: relative;
  z-index: 2;
}
#iris-recommend-ui .iiris-input-group-append .btn:focus,
#iris-recommend-ui .iiris-input-group-prepend .btn:focus {
  z-index: 3;
}
#iris-recommend-ui .iiris-input-group-append .btn + .btn,
#iris-recommend-ui .iiris-input-group-append .btn + .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-append .iiris-input-group-text + .btn,
#iris-recommend-ui
  .iiris-input-group-append
  .iiris-input-group-text
  + .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-prepend .btn + .btn,
#iris-recommend-ui .iiris-input-group-prepend .btn + .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-prepend .iiris-input-group-text + .btn,
#iris-recommend-ui
  .iiris-input-group-prepend
  .iiris-input-group-text
  + .iiris-input-group-text {
  margin-left: -1px;
}
#iris-recommend-ui .iiris-input-group-prepend {
  margin-right: -1px;
}
#iris-recommend-ui .iiris-input-group-append {
  margin-left: -1px;
}
#iris-recommend-ui .iiris-input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
#iris-recommend-ui .iiris-input-group-text input[type="checkbox"],
#iris-recommend-ui .iiris-input-group-text input[type="radio"] {
  margin-top: 0;
}
#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group-lg > .form-control:not(textarea) {
  height: calc(1.5em + 1rem + 2px);
}
#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group-lg > .form-control,
#iris-recommend-ui .iiris-input-group-lg > .iiris-input-group-append > .btn,
#iris-recommend-ui
  .iiris-input-group-lg
  > .iiris-input-group-append
  > .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-lg > .iiris-input-group-prepend > .btn,
#iris-recommend-ui
  .iiris-input-group-lg
  > .iiris-input-group-prepend
  > .iiris-input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
#iris-recommend-ui .iiris-input-group-sm > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group-sm > .form-control:not(textarea) {
  height: calc(1.5em + 0.5rem + 2px);
}
#iris-recommend-ui .iiris-input-group-sm > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group-sm > .form-control,
#iris-recommend-ui .iiris-input-group-sm > .iiris-input-group-append > .btn,
#iris-recommend-ui
  .iiris-input-group-sm
  > .iiris-input-group-append
  > .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-sm > .iiris-input-group-prepend > .btn,
#iris-recommend-ui
  .iiris-input-group-sm
  > .iiris-input-group-prepend
  > .iiris-input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group-sm > .iiris-custom-select {
  padding-right: 1.75rem;
}
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-append:last-child
  > .btn:not(:last-child):not(.dropdown-toggle),
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-append:last-child
  > .iiris-input-group-text:not(:last-child),
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-append:not(:last-child)
  > .btn,
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-append:not(:last-child)
  > .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group > .iiris-input-group-prepend > .btn,
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-prepend
  > .iiris-input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
#iris-recommend-ui .iiris-input-group > .iiris-input-group-append > .btn,
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-append
  > .iiris-input-group-text,
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-prepend:first-child
  > .btn:not(:first-child),
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-prepend:first-child
  > .iiris-input-group-text:not(:first-child),
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-prepend:not(:first-child)
  > .btn,
#iris-recommend-ui
  .iiris-input-group
  > .iiris-input-group-prepend:not(:first-child)
  > .iiris-input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
#iris-recommend-ui .iiris-form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  #iris-recommend-ui .iiris-form-control {
    transition: none;
  }
}
#iris-recommend-ui .iiris-form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
#iris-recommend-ui .iiris-form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
#iris-recommend-ui .iiris-form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
#iris-recommend-ui .iiris-form-control::-webkit-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
#iris-recommend-ui .iiris-form-control::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
#iris-recommend-ui .iiris-form-control:-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
#iris-recommend-ui .iiris-form-control::-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
#iris-recommend-ui .iiris-form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
#iris-recommend-ui .iiris-form-control:disabled,
#iris-recommend-ui .iiris-form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
#iris-recommend-ui input[type="date"].iiris-form-control,
#iris-recommend-ui input[type="datetime-local"].iiris-form-control,
#iris-recommend-ui input[type="month"].iiris-form-control,
#iris-recommend-ui input[type="time"].iiris-form-control {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
#iris-recommend-ui select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
#iris-recommend-ui .form-control-file,
#iris-recommend-ui .form-control-range {
  display: block;
  width: 100%;
}
#iris-recommend-ui .iiris-col .widget-label {
  -webkit-line-clamp: 1;
  line-height: 24px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: inherit;
}
#iris-recommend-ui .iiris-col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
#iris-recommend-ui .iiris-col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}
#iris-recommend-ui .iiris-col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}
#iris-recommend-ui .form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
#iris-recommend-ui .form-control-plaintext.form-control-lg,
#iris-recommend-ui .form-control-plaintext.form-control-sm {
  padding-right: 0;
  padding-left: 0;
}
#iris-recommend-ui .form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
#iris-recommend-ui .form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
#iris-recommend-ui select.form-control[multiple],
#iris-recommend-ui select.form-control[size] {
  height: auto;
}
#iris-recommend-ui textarea.form-control {
  height: auto;
}
#iris-recommend-ui .iiris-form-group {
  margin-bottom: 1rem;
}
#iris-recommend-ui .form-text {
  display: block;
  margin-top: 0.25rem;
}
#iris-recommend-ui .iiris-form-row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
#iris-recommend-ui .iiris-form-row > .iiris-col,
#iris-recommend-ui .col,
#iris-recommend-ui .iiris-form-row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}
#iris-recommend-ui .iiris-form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}
#iris-recommend-ui .iiris-form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
#iris-recommend-ui .iiris-form-check-input:disabled ~ .iiris-form-check-label,
#iris-recommend-ui .iiris-form-check-input[disabled] ~ .iiris-form-check-label {
  color: #6c757d;
}
#iris-recommend-ui .iiris-form-check-label {
  margin-bottom: 0;
}
#iris-recommend-ui .iiris-form-check-inline {
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
#iris-recommend-ui .iiris-form-check-inline .iiris-form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}
#iris-recommend-ui .valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #28a745;
}
#iris-recommend-ui .valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem;
}
#iris-recommend-ui .is-valid ~ .valid-feedback,
#iris-recommend-ui .is-valid ~ .valid-tooltip,
#iris-recommend-ui .was-validated :valid ~ .valid-feedback,
#iris-recommend-ui .was-validated :valid ~ .valid-tooltip {
  display: block;
}
#iris-recommend-ui .iiris-form-control.is-valid,
#iris-recommend-ui .was-validated .iiris-form-control:valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
#iris-recommend-ui .iiris-form-control.is-valid:focus,
#iris-recommend-ui .was-validated .iiris-form-control:valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
#iris-recommend-ui .was-validated textarea.form-control:valid,
#iris-recommend-ui textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right
    calc(0.375em + 0.1875rem);
}
#iris-recommend-ui .iiris-form-control.is-invalid,
#iris-recommend-ui .was-validated .iiris-form-control:invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
#iris-recommend-ui .iiris-form-control.is-invalid:focus,
#iris-recommend-ui .was-validated .iiris-form-control:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
#iris-recommend-ui .was-validated textarea.form-control:invalid,
#iris-recommend-ui textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right
    calc(0.375em + 0.1875rem);
}
#iris-recommend-ui .iiris-col-sm,
#iris-recommend-ui .col-sm {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 576px) {
  #iris-recommend-ui .iiris-col-sm,
  #iris-recommend-ui .col-sm {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%;
  }
}
#iris-recommend-ui .iiris-clearfix::after {
  display: block;
  clear: both;
  content: "";
}

#iris-recommend-ui dl,
#iris-recommend-ui ol,
#iris-recommend-ui ul {
  margin-top: 0;
  margin-bottom: 1rem;
}
#iris-recommend-ui ol ol,
#iris-recommend-ui ol ul,
#iris-recommend-ui ul ol,
#iris-recommend-ui ul ul {
  margin-bottom: 0;
}
#iris-recommend-ui svg {
  overflow: hidden;
  vertical-align: middle;
}
#iris-recommend-ui a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}
#iris-recommend-ui a:hover {
  color: #0056b3;
  text-decoration: underline;
}
#iris-recommend-ui a:not([href]) {
  color: inherit;
  text-decoration: none;
}
#iris-recommend-ui a:not([href]):hover {
  color: inherit;
  text-decoration: none;
}
#iris-recommend-ui h1,
#iris-recommend-ui h2,
#iris-recommend-ui h3,
#iris-recommend-ui h4,
#iris-recommend-ui h5,
#iris-recommend-ui h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
#iris-recommend-ui .h1,
#iris-recommend-ui .h2,
#iris-recommend-ui .h3,
#iris-recommend-ui .h4,
#iris-recommend-ui .h5,
#iris-recommend-ui .h6,
#iris-recommend-ui #iris-recommend-ui h1,
#iris-recommend-ui h2,
#iris-recommend-ui h3,
#iris-recommend-ui h4,
#iris-recommend-ui h5,
#iris-recommend-ui h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}
#iris-recommend-ui .h1,
#iris-recommend-ui h1 {
  font-size: 2.5rem;
}
#iris-recommend-ui .h2,
#iris-recommend-ui h2 {
  font-size: 2rem;
}
#iris-recommend-ui .h3,
#iris-recommend-ui h3 {
  font-size: 1.75rem;
}
#iris-recommend-ui .h4,
#iris-recommend-ui h4 {
  font-size: 1.5rem;
}
#iris-recommend-ui .h5,
#iris-recommend-ui h5 {
  font-size: 1.25rem;
}
#iris-recommend-ui .h6,
#iris-recommend-ui h6 {
  font-size: 1rem;
}
#iris-recommend-ui p {
  margin-top: 0;
  margin-bottom: 1rem;
}
#iris-recommend-ui .iiris-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  #iris-recommend-ui .iiris-container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  #iris-recommend-ui .iiris-container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  #iris-recommend-ui .iiris-container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  #iris-recommend-ui .iiris-container {
    max-width: 1140px;
  }
}
#iris-recommend-ui .iiris-container-fluid,
#iris-recommend-ui .iiris-container-lg,
#iris-recommend-ui .iiris-container-md,
#iris-recommend-ui .iiris-container-sm,
#iris-recommend-ui .iiris-container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  #iris-recommend-ui .iiris-container,
  #iris-recommend-ui .iiris-container-sm {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  #iris-recommend-ui .iiris-container,
  #iris-recommend-ui .iiris-container-md,
  #iris-recommend-ui .iiris-container-sm {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  #iris-recommend-ui .iiris-container,
  #iris-recommend-ui .iiris-container-lg,
  #iris-recommend-ui .iiris-container-md,
  #iris-recommend-ui .iiris-container-sm {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  #iris-recommend-ui .iiris-container,
  #iris-recommend-ui .iiris-container-lg,
  #iris-recommend-ui .iiris-container-md,
  #iris-recommend-ui .iiris-container-sm,
  #iris-recommend-ui .iiris-container-xl {
    max-width: 1140px;
  }
}
#iris-recommend-ui .iiris-col,
#iris-recommend-ui .col,
#iris-recommend-ui .iiris-col-1,
#iris-recommend-ui .iiris-col-10,
#iris-recommend-ui .iiris-col-11,
#iris-recommend-ui .iiris-col-12,
#iris-recommend-ui .iiris-col-2,
#iris-recommend-ui .iiris-col-3,
#iris-recommend-ui .iiris-col-4,
#iris-recommend-ui .iiris-col-5,
#iris-recommend-ui .iiris-col-6,
#iris-recommend-ui .iiris-col-7,
#iris-recommend-ui .iiris-col-8,
#iris-recommend-ui .iiris-col-9,
#iris-recommend-ui .iiris-col-auto,
#iris-recommend-ui .iiris-col-lg,
#iris-recommend-ui .iiris-col-lg-1,
#iris-recommend-ui .iiris-col-lg-10,
#iris-recommend-ui .iiris-col-lg-11,
#iris-recommend-ui .iiris-col-lg-12,
#iris-recommend-ui .iiris-col-lg-2,
#iris-recommend-ui .iiris-col-lg-3,
#iris-recommend-ui .iiris-col-lg-4,
#iris-recommend-ui .iiris-col-lg-5,
#iris-recommend-ui .iiris-col-lg-6,
#iris-recommend-ui .iiris-col-lg-7,
#iris-recommend-ui .iiris-col-lg-8,
#iris-recommend-ui .iiris-col-lg-9,
#iris-recommend-ui .iiris-col-lg-auto,
#iris-recommend-ui .iiris-col-md,
#iris-recommend-ui .iiris-col-md-1,
#iris-recommend-ui .iiris-col-md-10,
#iris-recommend-ui .iiris-col-md-11,
#iris-recommend-ui .iiris-col-md-12,
#iris-recommend-ui .iiris-col-md-2,
#iris-recommend-ui .iiris-col-md-3,
#iris-recommend-ui .iiris-col-md-4,
#iris-recommend-ui .iiris-col-md-5,
#iris-recommend-ui .iiris-col-md-6,
#iris-recommend-ui .iiris-col-md-7,
#iris-recommend-ui .iiris-col-md-8,
#iris-recommend-ui .iiris-col-md-9,
#iris-recommend-ui .iiris-col-md-auto,
#iris-recommend-ui .iiris-col-sm,
#iris-recommend-ui .iiris-col-sm-1,
#iris-recommend-ui .iiris-col-sm-10,
#iris-recommend-ui .iiris-col-sm-11,
#iris-recommend-ui .iiris-col-sm-12,
#iris-recommend-ui .iiris-col-sm-2,
#iris-recommend-ui .iiris-col-sm-3,
#iris-recommend-ui .iiris-col-sm-4,
#iris-recommend-ui .iiris-col-sm-5,
#iris-recommend-ui .iiris-col-sm-6,
#iris-recommend-ui .iiris-col-sm-7,
#iris-recommend-ui .iiris-col-sm-8,
#iris-recommend-ui .iiris-col-sm-9,
#iris-recommend-ui .iiris-col-sm-auto,
#iris-recommend-ui .iiris-col-xl,
#iris-recommend-ui .iiris-col-xl-1,
#iris-recommend-ui .iiris-col-xl-10,
#iris-recommend-ui .iiris-col-xl-11,
#iris-recommend-ui .iiris-col-xl-12,
#iris-recommend-ui .iiris-col-xl-2,
#iris-recommend-ui .iiris-col-xl-3,
#iris-recommend-ui .iiris-col-xl-4,
#iris-recommend-ui .iiris-col-xl-5,
#iris-recommend-ui .iiris-col-xl-6,
#iris-recommend-ui .iiris-col-xl-7,
#iris-recommend-ui .iiris-col-xl-8,
#iris-recommend-ui .iiris-col-xl-9,
#iris-recommend-ui .iiris-col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
#iris-recommend-ui .iiris-col,
#iris-recommend-ui .col {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  min-width: 0;
  max-width: 100%;
}
#iris-recommend-ui .row-iris-cols-1 > * {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
#iris-recommend-ui .row-iris-cols-2 > * {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
#iris-recommend-ui .row-iris-cols-3 > * {
  -ms-flex: 0 0 33.333333%;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}
#iris-recommend-ui .row-iris-cols-4 > * {
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
#iris-recommend-ui .row-iris-cols-5 > * {
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}
#iris-recommend-ui .row-iris-cols-6 > * {
  -ms-flex: 0 0 16.666667%;
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}
#iris-recommend-ui .iiris-col-auto {
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
#iris-recommend-ui .iiris-col-1,
#iris-recommend-ui .col-1 {
  -ms-flex: 0 0 8.333333%;
  flex: 0 0 8.333333%;
  max-width: 8.333333%;
}
#iris-recommend-ui .iiris-col-2,
#iris-recommend-ui .col-2 {
  -ms-flex: 0 0 16.666667%;
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}
#iris-recommend-ui .iiris-col-3,
#iris-recommend-ui .col-3 {
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
#iris-recommend-ui .iiris-col-4,
#iris-recommend-ui .col-4 {
  -ms-flex: 0 0 33.333333%;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}
#iris-recommend-ui .iiris-col-5,
#iris-recommend-ui .col-5 {
  -ms-flex: 0 0 41.666667%;
  flex: 0 0 41.666667%;
  max-width: 41.666667%;
}
#iris-recommend-ui .iiris-col-6,
#iris-recommend-ui .col-6 {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
#iris-recommend-ui .iiris-col-7,
#iris-recommend-ui .col-7 {
  -ms-flex: 0 0 58.333333%;
  flex: 0 0 58.333333%;
  max-width: 58.333333%;
}
#iris-recommend-ui .iiris-col-8,
#iris-recommend-ui .col-8 {
  -ms-flex: 0 0 66.666667%;
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}
#iris-recommend-ui .iiris-col-9,
#iris-recommend-ui .col-9 {
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}
#iris-recommend-ui .iiris-col-10,
#iris-recommend-ui .col-10 {
  -ms-flex: 0 0 83.333333%;
  flex: 0 0 83.333333%;
  max-width: 83.333333%;
}
#iris-recommend-ui .iiris-col-11,
#iris-recommend-ui .col-11 {
  -ms-flex: 0 0 91.666667%;
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
}
#iris-recommend-ui .iiris-col-12,
#iris-recommend-ui .col-12 {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
#iris-recommend-ui .order-first {
  -ms-flex-order: -1;
  order: -1;
}
#iris-recommend-ui .order-last {
  -ms-flex-order: 13;
  order: 13;
}
#iris-recommend-ui .order-0 {
  -ms-flex-order: 0;
  order: 0;
}
#iris-recommend-ui .order-1 {
  -ms-flex-order: 1;
  order: 1;
}
#iris-recommend-ui .order-2 {
  -ms-flex-order: 2;
  order: 2;
}
#iris-recommend-ui .order-3 {
  -ms-flex-order: 3;
  order: 3;
}
#iris-recommend-ui .order-4 {
  -ms-flex-order: 4;
  order: 4;
}
#iris-recommend-ui .order-5 {
  -ms-flex-order: 5;
  order: 5;
}
#iris-recommend-ui .order-6 {
  -ms-flex-order: 6;
  order: 6;
}
#iris-recommend-ui .order-7 {
  -ms-flex-order: 7;
  order: 7;
}
#iris-recommend-ui .order-8 {
  -ms-flex-order: 8;
  order: 8;
}
#iris-recommend-ui .order-9 {
  -ms-flex-order: 9;
  order: 9;
}
#iris-recommend-ui .order-10 {
  -ms-flex-order: 10;
  order: 10;
}
#iris-recommend-ui .order-11 {
  -ms-flex-order: 11;
  order: 11;
}
#iris-recommend-ui .order-12 {
  -ms-flex-order: 12;
  order: 12;
}
#iris-recommend-ui .offset-1 {
  margin-left: 8.333333%;
}
#iris-recommend-ui .offset-2 {
  margin-left: 16.666667%;
}
#iris-recommend-ui .offset-3 {
  margin-left: 25%;
}
#iris-recommend-ui .offset-4 {
  margin-left: 33.333333%;
}
#iris-recommend-ui .offset-5 {
  margin-left: 41.666667%;
}
#iris-recommend-ui .offset-6 {
  margin-left: 50%;
}
#iris-recommend-ui .offset-7 {
  margin-left: 58.333333%;
}
#iris-recommend-ui .offset-8 {
  margin-left: 66.666667%;
}
#iris-recommend-ui .offset-9 {
  margin-left: 75%;
}
#iris-recommend-ui .offset-10 {
  margin-left: 83.333333%;
}
#iris-recommend-ui .offset-11 {
  margin-left: 91.666667%;
}
@media (min-width: 576px) {
  #iris-recommend-ui .iiris-col-sm,
  #iris-recommend-ui .col-sm {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%;
  }

  #iris-recommend-ui .row-iris-cols-sm-1 > * {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  #iris-recommend-ui .row-iris-cols-sm-2 > * {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  #iris-recommend-ui .row-iris-cols-sm-3 > * {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  #iris-recommend-ui .row-iris-cols-sm-4 > * {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  #iris-recommend-ui .row-iris-cols-sm-5 > * {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }

  #iris-recommend-ui .row-iris-cols-sm-6 > * {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }

  #iris-recommend-ui .iiris-col-sm-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  #iris-recommend-ui .iiris-col-sm-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }

  #iris-recommend-ui .iiris-col-sm-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }

  #iris-recommend-ui .iiris-col-sm-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  #iris-recommend-ui .iiris-col-sm-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  #iris-recommend-ui .iiris-col-sm-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }

  #iris-recommend-ui .iiris-col-sm-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  #iris-recommend-ui .iiris-col-sm-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }

  #iris-recommend-ui .iiris-col-sm-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }

  #iris-recommend-ui .iiris-col-sm-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }

  #iris-recommend-ui .iiris-col-sm-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }

  #iris-recommend-ui .iiris-col-sm-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }

  #iris-recommend-ui .iiris-col-sm-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  #iris-recommend-ui .order-sm-first {
    -ms-flex-order: -1;
    order: -1;
  }

  #iris-recommend-ui .order-sm-last {
    -ms-flex-order: 13;
    order: 13;
  }

  #iris-recommend-ui .order-sm-0 {
    -ms-flex-order: 0;
    order: 0;
  }

  #iris-recommend-ui .order-sm-1 {
    -ms-flex-order: 1;
    order: 1;
  }

  #iris-recommend-ui .order-sm-2 {
    -ms-flex-order: 2;
    order: 2;
  }

  #iris-recommend-ui .order-sm-3 {
    -ms-flex-order: 3;
    order: 3;
  }

  #iris-recommend-ui .order-sm-4 {
    -ms-flex-order: 4;
    order: 4;
  }

  #iris-recommend-ui .order-sm-5 {
    -ms-flex-order: 5;
    order: 5;
  }

  #iris-recommend-ui .order-sm-6 {
    -ms-flex-order: 6;
    order: 6;
  }

  #iris-recommend-ui .order-sm-7 {
    -ms-flex-order: 7;
    order: 7;
  }

  #iris-recommend-ui .order-sm-8 {
    -ms-flex-order: 8;
    order: 8;
  }

  #iris-recommend-ui .order-sm-9 {
    -ms-flex-order: 9;
    order: 9;
  }

  #iris-recommend-ui .order-sm-10 {
    -ms-flex-order: 10;
    order: 10;
  }

  #iris-recommend-ui .order-sm-11 {
    -ms-flex-order: 11;
    order: 11;
  }

  #iris-recommend-ui .order-sm-12 {
    -ms-flex-order: 12;
    order: 12;
  }

  #iris-recommend-ui .offset-sm-0 {
    margin-left: 0;
  }

  #iris-recommend-ui .offset-sm-1 {
    margin-left: 8.333333%;
  }

  #iris-recommend-ui .offset-sm-2 {
    margin-left: 16.666667%;
  }

  #iris-recommend-ui .offset-sm-3 {
    margin-left: 25%;
  }

  #iris-recommend-ui .offset-sm-4 {
    margin-left: 33.333333%;
  }

  #iris-recommend-ui .offset-sm-5 {
    margin-left: 41.666667%;
  }

  #iris-recommend-ui .offset-sm-6 {
    margin-left: 50%;
  }

  #iris-recommend-ui .offset-sm-7 {
    margin-left: 58.333333%;
  }

  #iris-recommend-ui .offset-sm-8 {
    margin-left: 66.666667%;
  }

  #iris-recommend-ui .offset-sm-9 {
    margin-left: 75%;
  }

  #iris-recommend-ui .offset-sm-10 {
    margin-left: 83.333333%;
  }

  #iris-recommend-ui .offset-sm-11 {
    margin-left: 91.666667%;
  }
}
@media (min-width: 768px) {
  #iris-recommend-ui .iiris-col-md {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%;
  }

  #iris-recommend-ui .row-cols-md-1 > * {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  #iris-recommend-ui .row-cols-md-2 > * {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  #iris-recommend-ui .row-cols-md-3 > * {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  #iris-recommend-ui .row-cols-md-4 > * {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  #iris-recommend-ui .row-cols-md-5 > * {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }

  #iris-recommend-ui .row-cols-md-6 > * {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }

  #iris-recommend-ui .iiris-col-md-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  #iris-recommend-ui .iiris-col-md-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }

  #iris-recommend-ui .iiris-col-md-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }

  #iris-recommend-ui .iiris-col-md-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  #iris-recommend-ui .iiris-col-md-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  #iris-recommend-ui .iiris-col-md-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }

  #iris-recommend-ui .iiris-col-md-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  #iris-recommend-ui .iiris-col-md-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }

  #iris-recommend-ui .iiris-col-md-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }

  #iris-recommend-ui .iiris-col-md-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }

  #iris-recommend-ui .iiris-col-md-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }

  #iris-recommend-ui .iiris-col-md-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }

  #iris-recommend-ui .iiris-col-md-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  #iris-recommend-ui .order-md-first {
    -ms-flex-order: -1;
    order: -1;
  }

  #iris-recommend-ui .order-md-last {
    -ms-flex-order: 13;
    order: 13;
  }

  #iris-recommend-ui .order-md-0 {
    -ms-flex-order: 0;
    order: 0;
  }

  #iris-recommend-ui .order-md-1 {
    -ms-flex-order: 1;
    order: 1;
  }

  #iris-recommend-ui .order-md-2 {
    -ms-flex-order: 2;
    order: 2;
  }

  #iris-recommend-ui .order-md-3 {
    -ms-flex-order: 3;
    order: 3;
  }

  #iris-recommend-ui .order-md-4 {
    -ms-flex-order: 4;
    order: 4;
  }

  #iris-recommend-ui .order-md-5 {
    -ms-flex-order: 5;
    order: 5;
  }

  #iris-recommend-ui .order-md-6 {
    -ms-flex-order: 6;
    order: 6;
  }

  #iris-recommend-ui .order-md-7 {
    -ms-flex-order: 7;
    order: 7;
  }

  #iris-recommend-ui .order-md-8 {
    -ms-flex-order: 8;
    order: 8;
  }

  #iris-recommend-ui .order-md-9 {
    -ms-flex-order: 9;
    order: 9;
  }

  #iris-recommend-ui .order-md-10 {
    -ms-flex-order: 10;
    order: 10;
  }

  #iris-recommend-ui .order-md-11 {
    -ms-flex-order: 11;
    order: 11;
  }

  #iris-recommend-ui .order-md-12 {
    -ms-flex-order: 12;
    order: 12;
  }

  #iris-recommend-ui .offset-md-0 {
    margin-left: 0;
  }

  #iris-recommend-ui .offset-md-1 {
    margin-left: 8.333333%;
  }

  #iris-recommend-ui .offset-md-2 {
    margin-left: 16.666667%;
  }

  #iris-recommend-ui .offset-md-3 {
    margin-left: 25%;
  }

  #iris-recommend-ui .offset-md-4 {
    margin-left: 33.333333%;
  }

  #iris-recommend-ui .offset-md-5 {
    margin-left: 41.666667%;
  }

  #iris-recommend-ui .offset-md-6 {
    margin-left: 50%;
  }

  #iris-recommend-ui .offset-md-7 {
    margin-left: 58.333333%;
  }

  #iris-recommend-ui .offset-md-8 {
    margin-left: 66.666667%;
  }

  #iris-recommend-ui .offset-md-9 {
    margin-left: 75%;
  }

  #iris-recommend-ui .offset-md-10 {
    margin-left: 83.333333%;
  }

  #iris-recommend-ui .offset-md-11 {
    margin-left: 91.666667%;
  }
}
@media (min-width: 992px) {
  #iris-recommend-ui .iiris-col-lg {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%;
  }

  #iris-recommend-ui .row-cols-lg-1 > * {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  #iris-recommend-ui .row-cols-lg-2 > * {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  #iris-recommend-ui .row-cols-lg-3 > * {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  #iris-recommend-ui .row-cols-lg-4 > * {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  #iris-recommend-ui .row-cols-lg-5 > * {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }

  #iris-recommend-ui .row-cols-lg-6 > * {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }

  #iris-recommend-ui .iiris-col-lg-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  #iris-recommend-ui .iiris-col-lg-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }

  #iris-recommend-ui .iiris-col-lg-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }

  #iris-recommend-ui .iiris-col-lg-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  #iris-recommend-ui .iiris-col-lg-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  #iris-recommend-ui .iiris-col-lg-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }

  #iris-recommend-ui .iiris-col-lg-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  #iris-recommend-ui .iiris-col-lg-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }

  #iris-recommend-ui .iiris-col-lg-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }

  #iris-recommend-ui .iiris-col-lg-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }

  #iris-recommend-ui .iiris-col-lg-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }

  #iris-recommend-ui .iiris-col-lg-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }

  #iris-recommend-ui .iiris-col-lg-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  #iris-recommend-ui .order-lg-first {
    -ms-flex-order: -1;
    order: -1;
  }

  #iris-recommend-ui .order-lg-last {
    -ms-flex-order: 13;
    order: 13;
  }

  #iris-recommend-ui .order-lg-0 {
    -ms-flex-order: 0;
    order: 0;
  }

  #iris-recommend-ui .order-lg-1 {
    -ms-flex-order: 1;
    order: 1;
  }

  #iris-recommend-ui .order-lg-2 {
    -ms-flex-order: 2;
    order: 2;
  }

  #iris-recommend-ui .order-lg-3 {
    -ms-flex-order: 3;
    order: 3;
  }

  #iris-recommend-ui .order-lg-4 {
    -ms-flex-order: 4;
    order: 4;
  }

  #iris-recommend-ui .order-lg-5 {
    -ms-flex-order: 5;
    order: 5;
  }

  #iris-recommend-ui .order-lg-6 {
    -ms-flex-order: 6;
    order: 6;
  }

  #iris-recommend-ui .order-lg-7 {
    -ms-flex-order: 7;
    order: 7;
  }

  #iris-recommend-ui .order-lg-8 {
    -ms-flex-order: 8;
    order: 8;
  }

  #iris-recommend-ui .order-lg-9 {
    -ms-flex-order: 9;
    order: 9;
  }

  #iris-recommend-ui .order-lg-10 {
    -ms-flex-order: 10;
    order: 10;
  }

  #iris-recommend-ui .order-lg-11 {
    -ms-flex-order: 11;
    order: 11;
  }

  #iris-recommend-ui .order-lg-12 {
    -ms-flex-order: 12;
    order: 12;
  }

  #iris-recommend-ui .offset-lg-0 {
    margin-left: 0;
  }

  #iris-recommend-ui .offset-lg-1 {
    margin-left: 8.333333%;
  }

  #iris-recommend-ui .offset-lg-2 {
    margin-left: 16.666667%;
  }

  #iris-recommend-ui .offset-lg-3 {
    margin-left: 25%;
  }

  #iris-recommend-ui .offset-lg-4 {
    margin-left: 33.333333%;
  }

  #iris-recommend-ui .offset-lg-5 {
    margin-left: 41.666667%;
  }

  #iris-recommend-ui .offset-lg-6 {
    margin-left: 50%;
  }

  #iris-recommend-ui .offset-lg-7 {
    margin-left: 58.333333%;
  }

  #iris-recommend-ui .offset-lg-8 {
    margin-left: 66.666667%;
  }

  #iris-recommend-ui .offset-lg-9 {
    margin-left: 75%;
  }

  #iris-recommend-ui .offset-lg-10 {
    margin-left: 83.333333%;
  }

  #iris-recommend-ui .offset-lg-11 {
    margin-left: 91.666667%;
  }
}
@media (min-width: 1200px) {
  #iris-recommend-ui .iiris-col-xl {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%;
  }

  #iris-recommend-ui .row-cols-xl-1 > * {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  #iris-recommend-ui .row-cols-xl-2 > * {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  #iris-recommend-ui .row-cols-xl-3 > * {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  #iris-recommend-ui .row-cols-xl-4 > * {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  #iris-recommend-ui .row-cols-xl-5 > * {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }

  #iris-recommend-ui .row-cols-xl-6 > * {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }

  #iris-recommend-ui .iiris-col-xl-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  #iris-recommend-ui .iiris-col-xl-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }

  #iris-recommend-ui .iiris-col-xl-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }

  #iris-recommend-ui .iiris-col-xl-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  #iris-recommend-ui .iiris-col-xl-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  #iris-recommend-ui .iiris-col-xl-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }

  #iris-recommend-ui .iiris-col-xl-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  #iris-recommend-ui .iiris-col-xl-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }

  #iris-recommend-ui .iiris-col-xl-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }

  #iris-recommend-ui .iiris-col-xl-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }

  #iris-recommend-ui .iiris-col-xl-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }

  #iris-recommend-ui .iiris-col-xl-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }

  #iris-recommend-ui .iiris-col-xl-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  #iris-recommend-ui .order-xl-first {
    -ms-flex-order: -1;
    order: -1;
  }
}

#iris-recommend-ui .iiris-row,
#iris-recommend-ui .row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

#iris-recommend-ui button,
#iris-recommend-ui input,
#iris-recommend-ui optgroup,
#iris-recommend-ui select,
#iris-recommend-ui textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

#iris-recommend-ui button,
#iris-recommend-ui input {
  overflow: visible;
}

#iris-recommend-ui button,
#iris-recommend-ui select {
  text-transform: none;
}

#iris-recommend-ui [role="button"] {
  cursor: pointer;
}

#iris-recommend-ui select {
  word-wrap: normal;
}
#iris-recommend-ui select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
#iris-recommend-ui select.form-control[multiple],
#iris-recommend-ui select.form-control[size] {
  height: auto;
}

#iris-recommend-ui textarea.form-control {
  height: auto;
}

#iris-recommend-ui .form-check-input.is-valid ~ .form-check-label,
#iris-recommend-ui .was-validated .form-check-input:valid ~ .form-check-label {
  color: #28a745;
}

#iris-recommend-ui .form-check-input.is-valid ~ .valid-feedback,
#iris-recommend-ui .form-check-input.is-valid ~ .valid-tooltip,
#iris-recommend-ui .was-validated .form-check-input:valid ~ .valid-feedback,
#iris-recommend-ui .was-validated .form-check-input:valid ~ .valid-tooltip {
  display: block;
}

#iris-recommend-ui .custom-control-input.is-valid ~ .custom-control-label,
#iris-recommend-ui
  .was-validated
  .custom-control-input:valid
  ~ .custom-control-label {
  color: #28a745;
}

#iris-recommend-ui
  .custom-control-input.is-valid
  ~ .custom-control-label::before,
#iris-recommend-ui
  .was-validated
  .custom-control-input:valid
  ~ .custom-control-label::before {
  border-color: #28a745;
}

#iris-recommend-ui
  .custom-control-input.is-valid:checked
  ~ .custom-control-label::before,
#iris-recommend-ui
  .was-validated
  .custom-control-input:valid:checked
  ~ .custom-control-label::before {
  border-color: #34ce57;
  background-color: #34ce57;
}

#iris-recommend-ui
  .custom-control-input.is-valid:focus
  ~ .custom-control-label::before,
#iris-recommend-ui
  .was-validated
  .custom-control-input:valid:focus
  ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

#iris-recommend-ui
  .custom-control-input.is-valid:focus:not(:checked)
  ~ .custom-control-label::before,
#iris-recommend-ui
  .was-validated
  .custom-control-input:valid:focus:not(:checked)
  ~ .custom-control-label::before {
  border-color: #28a745;
}

#iris-recommend-ui .custom-file-input.is-valid ~ .custom-file-label,
#iris-recommend-ui
  .was-validated
  .custom-file-input:valid
  ~ .custom-file-label {
  border-color: #28a745;
}

#iris-recommend-ui .custom-file-input.is-valid:focus ~ .custom-file-label,
#iris-recommend-ui
  .was-validated
  .custom-file-input:valid:focus
  ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

#iris-recommend-ui .invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

#iris-recommend-ui .invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}

#iris-recommend-ui .is-invalid ~ .invalid-feedback,
#iris-recommend-ui .is-invalid ~ .invalid-tooltip,
#iris-recommend-ui .was-validated :invalid ~ .invalid-feedback,
#iris-recommend-ui .was-validated :invalid ~ .invalid-tooltip {
  display: block;
}

#iris-recommend-ui .form-control.is-invalid,
#iris-recommend-ui .was-validated .form-control:invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
#iris-recommend-ui .form-control.is-invalid:focus,
#iris-recommend-ui .was-validated .form-control:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
#iris-recommend-ui .was-validated textarea.form-control:invalid,
#iris-recommend-ui textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right
    calc(0.375em + 0.1875rem);
}
#iris-recommend-ui .iiris-custom-select.is-invalid,
#iris-recommend-ui .was-validated .iiris-custom-select:invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem);
  background:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___})
      no-repeat right 0.75rem center/8px 10px,
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      #fff no-repeat center right 1.75rem / calc(0.75em + 0.375rem)
      calc(0.75em + 0.375rem);
}
#iris-recommend-ui .iiris-custom-select.is-invalid:focus,
#iris-recommend-ui .was-validated .iiris-custom-select:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
#iris-recommend-ui .form-check-input.is-invalid ~ .form-check-label,
#iris-recommend-ui
  .was-validated
  .form-check-input:invalid
  ~ .form-check-label {
  color: #dc3545;
}
#iris-recommend-ui .form-check-input.is-invalid ~ .invalid-feedback,
#iris-recommend-ui .form-check-input.is-invalid ~ .invalid-tooltip,
#iris-recommend-ui .was-validated .form-check-input:invalid ~ .invalid-feedback,
#iris-recommend-ui .was-validated .form-check-input:invalid ~ .invalid-tooltip {
  display: block;
}
#iris-recommend-ui .custom-control-input.is-invalid ~ .custom-control-label,
#iris-recommend-ui
  .was-validated
  .custom-control-input:invalid
  ~ .custom-control-label {
  color: #dc3545;
}
#iris-recommend-ui
  .custom-control-input.is-invalid
  ~ .custom-control-label::before,
#iris-recommend-ui
  .was-validated
  .custom-control-input:invalid
  ~ .custom-control-label::before {
  border-color: #dc3545;
}
#iris-recommend-ui
  .custom-control-input.is-invalid:checked
  ~ .custom-control-label::before,
#iris-recommend-ui
  .was-validated
  .custom-control-input:invalid:checked
  ~ .custom-control-label::before {
  border-color: #e4606d;
  background-color: #e4606d;
}
#iris-recommend-ui
  .custom-control-input.is-invalid:focus
  ~ .custom-control-label::before,
#iris-recommend-ui
  .was-validated
  .custom-control-input:invalid:focus
  ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
#iris-recommend-ui
  .custom-control-input.is-invalid:focus:not(:checked)
  ~ .custom-control-label::before,
#iris-recommend-ui
  .was-validated
  .custom-control-input:invalid:focus:not(:checked)
  ~ .custom-control-label::before {
  border-color: #dc3545;
}
#iris-recommend-ui .custom-file-input.is-invalid ~ .custom-file-label,
#iris-recommend-ui
  .was-validated
  .custom-file-input:invalid
  ~ .custom-file-label {
  border-color: #dc3545;
}
#iris-recommend-ui .custom-file-input.is-invalid:focus ~ .custom-file-label,
#iris-recommend-ui
  .was-validated
  .custom-file-input:invalid:focus
  ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
#iris-recommend-ui .custom-file,
#iris-recommend-ui .iiris-input-group > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group > .form-control,
#iris-recommend-ui .iiris-input-group > .form-control-plaintext {
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
#iris-recommend-ui .iiris-input-group > .custom-file + .custom-file,
#iris-recommend-ui .iiris-input-group > .custom-file + .iiris-custom-select,
#iris-recommend-ui .iiris-input-group > .custom-file + .form-control,
#iris-recommend-ui .iiris-input-group > .iiris-custom-select + .custom-file,
#iris-recommend-ui
  .iiris-input-group
  > .iiris-custom-select
  + .iiris-custom-select,
#iris-recommend-ui .iiris-input-group > .iiris-custom-select + .form-control,
#iris-recommend-ui .iiris-input-group > .form-control + .custom-file,
#iris-recommend-ui .iiris-input-group > .form-control + .iiris-custom-select,
#iris-recommend-ui .iiris-input-group > .form-control + .form-control,
#iris-recommend-ui .iiris-input-group > .form-control-plaintext + .custom-file,
#iris-recommend-ui
  .iiris-input-group
  > .form-control-plaintext
  + .iiris-custom-select,
#iris-recommend-ui
  .iiris-input-group
  > .form-control-plaintext
  + .form-control {
  margin-left: -1px;
}
#iris-recommend-ui
  .iiris-input-group
  > .custom-file
  .custom-file-input:focus
  ~ .custom-file-label,
#iris-recommend-ui .iiris-input-group > .iiris-custom-select:focus,
#iris-recommend-ui .iiris-input-group > .form-control:focus {
  z-index: 3;
}
#iris-recommend-ui .iiris-input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
#iris-recommend-ui .iiris-input-group > .iiris-custom-select:not(:last-child),
#iris-recommend-ui .iiris-input-group > .form-control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
#iris-recommend-ui .iiris-input-group > .iiris-custom-select:not(:first-child),
#iris-recommend-ui .iiris-input-group > .form-control:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
#iris-recommend-ui .iiris-input-group > .custom-file {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}
#iris-recommend-ui
  .iiris-input-group
  > .custom-file:not(:last-child)
  .custom-file-label,
#iris-recommend-ui
  .iiris-input-group
  > .custom-file:not(:last-child)
  .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
#iris-recommend-ui
  .iiris-input-group
  > .custom-file:not(:first-child)
  .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
#iris-recommend-ui .iiris-input-group-append,
#iris-recommend-ui .iiris-input-group-prepend {
  display: -ms-flexbox;
  display: flex;
}
#iris-recommend-ui .iiris-input-group-append .btn,
#iris-recommend-ui .iiris-input-group-prepend .btn {
  position: relative;
  z-index: 2;
}
#iris-recommend-ui .iiris-input-group-append .btn:focus,
#iris-recommend-ui .iiris-input-group-prepend .btn:focus {
  z-index: 3;
}
#iris-recommend-ui .iiris-input-group-append .btn + .btn,
#iris-recommend-ui .iiris-input-group-append .btn + .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-append .iiris-input-group-text + .btn,
#iris-recommend-ui
  .iiris-input-group-append
  .iiris-input-group-text
  + .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-prepend .btn + .btn,
#iris-recommend-ui .iiris-input-group-prepend .btn + .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-prepend .iiris-input-group-text + .btn,
#iris-recommend-ui
  .iiris-input-group-prepend
  .iiris-input-group-text
  + .iiris-input-group-text {
  margin-left: -1px;
}
#iris-recommend-ui .iiris-input-group-prepend {
  margin-right: -1px;
}
#iris-recommend-ui .iiris-input-group-append {
  margin-left: -1px;
}
#iris-recommend-ui .iiris-input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
#iris-recommend-ui .iiris-input-group-text input[type="checkbox"],
#iris-recommend-ui .iiris-input-group-text input[type="radio"] {
  margin-top: 0;
}
#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group-lg > .form-control:not(textarea) {
  height: calc(1.5em + 1rem + 2px);
}
#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,
#iris-recommend-ui .iiris-input-group-lg > .form-control,
#iris-recommend-ui .iiris-input-group-lg > .iiris-input-group-append > .btn,
#iris-recommend-ui
  .iiris-input-group-lg
  > .iiris-input-group-append
  > .iiris-input-group-text,
#iris-recommend-ui .iiris-input-group-lg > .iiris-input-group-prepend > .btn,
#iris-recommend-ui
  .iiris-input-group-lg
  > .iiris-input-group-prepend
  > .iiris-input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
#iris-recommend-ui .iiris-custom-select-sm > .iiris-custom-select,
#iris-recommend-ui .iiris-custom-select-sm > .form-control:not(textarea) {
  height: calc(1.5em + 0.5rem + 2px);
}
#iris-recommend-ui .iiris-custom-select-sm > .iiris-custom-select,
#iris-recommend-ui .iiris-custom-select-sm > .form-control,
#iris-recommend-ui .iiris-custom-select-sm > .iiris-custom-select-append > .btn,
#iris-recommend-ui
  .iiris-custom-select-sm
  > .iiris-custom-select-append
  > .iiris-custom-select-text,
#iris-recommend-ui
  .iiris-custom-select-sm
  > .iiris-custom-select-prepend
  > .btn,
#iris-recommend-ui
  .iiris-custom-select-sm
  > .iiris-custom-select-prepend
  > .iiris-custom-select-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

#iris-recommend-ui .iiris-custom-select-lg > .iiris-custom-select,
#iris-recommend-ui .iiris-custom-select-sm > .iiris-custom-select {
  padding-right: 1.75rem;
}
#iris-recommend-ui .iiris-custom-select.is-valid:focus,
#iris-recommend-ui .was-validated .iiris-custom-select:valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
#iris-recommend-ui .iiris-mb-3,
#iris-recommend-ui .iiris-my-3 {
  margin-bottom: 1rem !important;
}
#iris-recommend-ui .iiris-mb-4 {
  margin-bottom: 4rem !important;
}
#iris-recommend-ui .iiris-card,
#iris-recommend-ui .card > hr {
  margin-right: 0;
  margin-left: 0;
}
#iris-recommend-ui .iiris-card,
#iris-recommend-ui .card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
#iris-recommend-ui .iiris-card,
#iris-recommend-ui .card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
#iris-recommend-ui .iiris-card,
#iris-recommend-ui .card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
#iris-recommend-ui .iiris-card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}
#iris-recommend-ui .iiris-card-title {
  margin-bottom: 0.75rem;
}
#iris-recommend-ui .iiris-card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}
#iris-recommend-ui .iiris-card-text:last-child {
  margin-bottom: 0;
}
#iris-recommend-ui .iiris-card-link:hover {
  text-decoration: none;
}
#iris-recommend-ui .iiris-card-link + .iiris-card-link {
  margin-left: 1.25rem;
}
#iris-recommend-ui .iiris-card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
#iris-recommend-ui .iiris-card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
#iris-recommend-ui
  .iiris-card-header
  + .list-group
  .list-group-item:first-child {
  border-top: 0;
}
#iris-recommend-ui .iiris-card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
#iris-recommend-ui .iiris-card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}
#iris-recommend-ui .iiris-card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}
#iris-recommend-ui .iiris-card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
#iris-recommend-ui .iiris-card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
}
#iris-recommend-ui .iiris-card-img,
#iris-recommend-ui .iiris-card-img-bottom,
#iris-recommend-ui .iiris-card-img-top {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
}
#iris-recommend-ui .iiris-card-img,
#iris-recommend-ui .iiris-card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
#iris-recommend-ui .iiris-card-img,
#iris-recommend-ui .iiris-card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
#iris-recommend-ui .iiris-card-deck .iiris-card,
#iris-recommend-ui .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  #iris-recommend-ui .iiris-card-deck {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  #iris-recommend-ui .iiris-card-deck .iiris-card,
  #iris-recommend-ui .card {
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

#iris-recommend-ui .iiris-card-group > .iiris-card,
#iris-recommend-ui .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  #iris-recommend-ui .iiris-card-group {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
  }
  #iris-recommend-ui .iiris-card-group > .iiris-card,
  #iris-recommend-ui .card {
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  #iris-recommend-ui .iiris-card-group > .iiris-card + .iiris-card,
  #iris-recommend-ui .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  #iris-recommend-ui .iiris-card-group > .iiris-card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  #iris-recommend-ui
    .iiris-card-group
    > .iiris-card:not(:last-child)
    .iiris-card-header,
  #iris-recommend-ui
    .iiris-card-group
    > .iiris-card:not(:last-child)
    .iiris-card-img-top {
    border-top-right-radius: 0;
  }
  #iris-recommend-ui
    .iiris-card-group
    > .iiris-card:not(:last-child)
    .iiris-card-footer,
  #iris-recommend-ui
    .iiris-card-group
    > .iiris-card:not(:last-child)
    .iiris-card-img-bottom {
    border-bottom-right-radius: 0;
  }
  #iris-recommend-ui .iiris-card-group > .iiris-card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  #iris-recommend-ui
    .iiris-card-group
    > .iiris-card:not(:first-child)
    .iiris-card-header,
  #iris-recommend-ui
    .iiris-card-group
    > .iiris-card:not(:first-child)
    .iiris-card-img-top {
    border-top-left-radius: 0;
  }
  #iris-recommend-ui
    .iiris-card-group
    > .iiris-card:not(:first-child)
    .iiris-card-footer,
  #iris-recommend-ui
    .iiris-card-group
    > .iiris-card:not(:first-child)
    .iiris-card-img-bottom {
    border-bottom-left-radius: 0;
  }
}

#iris-recommend-ui .iiris-card-columns .iiris-card,
#iris-recommend-ui .card {
  margin-bottom: 0.75rem;
}

@media (min-width: 576px) {
  #iris-recommend-ui .iiris-card-columns {
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    -webkit-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  #iris-recommend-ui .iiris-card-columns .iiris-card,
  #iris-recommend-ui .card {
    display: inline-block;
    width: 100%;
  }
}
#iris-recommend-ui .iiris-accordion > .iiris-card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
#iris-recommend-ui .iiris-accordion > .iiris-card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
#iris-recommend-ui .iiris-accordion > .iiris-card > .iiris-card-header {
  border-radius: 0;
  margin-bottom: -1px;
}
#iris-recommend-ui .iiris-text-muted {
  color: #6c757d !important;
}
#iris-recommend-ui label {
  display: inline-block;
  margin-bottom: 0.5rem;
}
#iris-recommend-ui .iiris-custom-select.is-valid:focus,
#iris-recommend-ui .was-validated .iiris-custom-select:valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
#iris-recommend-ui .iiris-custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff
    url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
#iris-recommend-ui .iiris-custom-select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
#iris-recommend-ui .iiris-custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
#iris-recommend-ui .iiris-custom-select[multiple],
#iris-recommend-ui .iiris-custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
#iris-recommend-ui .iiris-custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
#iris-recommend-ui .iiris-custom-select::-ms-expand {
  display: none;
}
#iris-recommend-ui .iiris-custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
#iris-recommend-ui .iiris-custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}
#iris-recommend-ui .iiris-custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}
#iris-recommend-ui .custom-control-label::before,
#iris-recommend-ui .custom-file-label,
#iris-recommend-ui .iiris-custom-select {
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  #iris-recommend-ui .custom-control-label::before,
  #iris-recommend-ui .custom-file-label,
  #iris-recommend-ui .iiris-custom-select {
    transition: none;
  }
}

*,
*::before,
*::after {
  box-sizing: border-box;
}
#iris-recommend-ui .carousel {
  position: relative;
}

#iris-recommend-ui .carousel.pointer-event {
  -ms-touch-action: pan-y;
  touch-action: pan-y;
}

#iris-recommend-ui .carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
  z-index: 2;
}

#iris-recommend-ui .carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

#iris-recommend-ui .carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  margin-bottom: 20px;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transition: -webkit-transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
  transition:
    transform 0.6s ease-in-out,
    -webkit-transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  #iris-recommend-ui .carousel-item {
    transition: none;
  }
}
#iris-recommend-ui .carousel-item.active,
#iris-recommend-ui .carousel-item-next,
#iris-recommend-ui .carousel-item-prev {
  display: block;
}
#iris-recommend-ui .carousel-item-next:not(.carousel-item-left),
#iris-recommend-ui .active.carousel-item-right {
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}
#iris-recommend-ui .carousel-item-prev:not(.carousel-item-right),
#iris-recommend-ui .active.carousel-item-left {
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
#iris-recommend-ui .carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  -webkit-transform: none;
  transform: none;
}
#iris-recommend-ui .carousel-fade .carousel-item.active,
#iris-recommend-ui .carousel-fade .carousel-item-next.carousel-item-left,
#iris-recommend-ui .carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
#iris-recommend-ui .carousel-fade .active.carousel-item-left,
#iris-recommend-ui .carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: 0s 0.6s opacity;
}
@media (prefers-reduced-motion: reduce) {
  #iris-recommend-ui .carousel-fade .active.carousel-item-left,
  #iris-recommend-ui .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}
#iris-recommend-ui .carousel-control-prev,
#iris-recommend-ui .carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  #iris-recommend-ui .carousel-control-prev,
  #iris-recommend-ui .carousel-control-next {
    transition: none;
  }
}
#iris-recommend-ui .carousel-control-prev:hover,
.carousel-control-prev:focus,
#iris-recommend-ui .carousel-control-next:hover,
#iris-recommend-ui .carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}
#iris-recommend-ui .carousel-control-prev {
  left: 0;
  margin-left: -10%;
}
#iris-recommend-ui .carousel-control-next {
  right: 0;
  margin-right: -10%;
}
#iris-recommend-ui .carousel-control-prev-icon,
#iris-recommend-ui .carousel-control-next-icon {
  width: 35px;
  height: 35px;
  background-color: #fffcfc;
  border-radius: 32px;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 15px rgb(36 38 38 / 36%);
  position: absolute;
  z-index: 2;
  display: inline-block;
  background-position-x: center;
  background-position-y: center;
  background-size: 60% 100%;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-repeat: no-repeat;
}
#iris-recommend-ui .carousel-control-prev-icon:hover,
#iris-recommend-ui .carousel-control-next-icon:hover,
#iris-recommend-ui .rec-arrow-left:hover,
#iris-recommend-ui .rec-arrow-right:hover,
#iris-recommend-ui .rec-arrow-down:hover,
.rec-arrow-up:hover,
#iris-recommend-ui .rec-arrow-left:focus,
#iris-recommend-ui .rec-arrow-right:focus,
#iris-recommend-ui .rec-arrow-down:focus,
.rec-arrow-up:focus {
  box-shadow: 0 3px 20px rgb(36 38 38 / 63%) !important;
  background-color: inherit !important;
}
#iris-recommend-ui .rec-arrow-left:disabled,
.rec-arrow-right:disabled,
.rec-arrow-down:disabled,
.rec-arrow-up:disabled {
  opacity: 0.5;
}
#iris-recommend-ui .carousel-control-prev-icon,
.rec-arrow-left {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
#iris-recommend-ui .carousel-control-next-icon,
.rec-arrow-right {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
#iris-recommend-ui .rec-arrow-down {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  transform: rotate(268deg) !important;
  -webkit-transform: rotate(268deg) !important;
  -moz-transform: rotate(268deg) !important;
  -o-transform: rotate(268deg) !important;
  -ms-transform: rotate(268deg) !important;
  bottom: -30px !important;
  left: calc(50% + -14px) !important;
  position: absolute;
}
#iris-recommend-ui .rec-arrow-up {
  position: absolute;
  transform: rotate(90deg);
  top: -60px !important;
  left: calc(50% + -14px) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
#iris-recommend-ui .carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
#iris-recommend-ui .carousel-indicators li {
  box-sizing: content-box;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  #iris-recommend-ui .carousel-indicators li {
    transition: none;
  }
}
#iris-recommend-ui .carousel-indicators .active {
  opacity: 1;
}
#iris-recommend-ui .carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}
#iris-recommend-ui .visually-hidden {
  visibility: hidden;
}
#iris-recommend-ui img {
  vertical-align: middle;
  border-style: none;
}
#iris-recommend-ui .popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
#iris-recommend-ui .popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
#iris-recommend-ui .popover .arrow::before,
.popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}
#iris-recommend-ui .bs-popover-top,
.bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem;
}
#iris-recommend-ui .bs-popover-top > .arrow,
.bs-popover-auto[x-placement^="top"] > .arrow {
  bottom: calc((0.5rem + 1px) * -1);
}
#iris-recommend-ui .bs-popover-top > .arrow::before,
.bs-popover-auto[x-placement^="top"] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
#iris-recommend-ui .bs-popover-top > .arrow::after,
.bs-popover-auto[x-placement^="top"] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}
#iris-recommend-ui .bs-popover-right,
.bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem;
}
#iris-recommend-ui .bs-popover-right > .arrow,
.bs-popover-auto[x-placement^="right"] > .arrow {
  left: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
#iris-recommend-ui .bs-popover-right > .arrow::before,
.bs-popover-auto[x-placement^="right"] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
#iris-recommend-ui .bs-popover-right > .arrow::after,
.bs-popover-auto[x-placement^="right"] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}
#iris-recommend-ui .bs-popover-bottom,
.bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem;
}
#iris-recommend-ui .bs-popover-bottom > .arrow,
.bs-popover-auto[x-placement^="bottom"] > .arrow {
  top: calc((0.5rem + 1px) * -1);
}
#iris-recommend-ui .bs-popover-bottom > .arrow::before,
.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
#iris-recommend-ui .bs-popover-bottom > .arrow::after,
.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
#iris-recommend-ui .bs-popover-bottom .popover-header::before,
.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}
#iris-recommend-ui .bs-popover-left,
.bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem;
}
#iris-recommend-ui .bs-popover-left > .arrow,
.bs-popover-auto[x-placement^="left"] > .arrow {
  right: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
#iris-recommend-ui .bs-popover-left > .arrow::before,
.bs-popover-auto[x-placement^="left"] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
#iris-recommend-ui .bs-popover-left > .arrow::after,
.bs-popover-auto[x-placement^="left"] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}
#iris-recommend-ui .popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
#iris-recommend-ui .popover-header:empty {
  display: none;
}
#iris-recommend-ui .popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}
#iris-recommend-ui .tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
#iris-recommend-ui .tooltip.show {
  opacity: 0.9;
}
#iris-recommend-ui .tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
#iris-recommend-ui .tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}
#iris-recommend-ui .bs-tooltip-top,
.bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0;
}
#iris-recommend-ui .bs-tooltip-top .arrow,
.bs-tooltip-auto[x-placement^="top"] .arrow {
  bottom: 0;
}
#iris-recommend-ui .bs-tooltip-top .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}
#iris-recommend-ui .bs-tooltip-right,
.bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem;
}
#iris-recommend-ui .bs-tooltip-right .arrow,
.bs-tooltip-auto[x-placement^="right"] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
#iris-recommend-ui .bs-tooltip-right .arrow::before,
.bs-tooltip-auto[x-placement^="right"] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}
#iris-recommend-ui .bs-tooltip-bottom,
.bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0;
}
#iris-recommend-ui .bs-tooltip-bottom .arrow,
.bs-tooltip-auto[x-placement^="bottom"] .arrow {
  top: 0;
}
#iris-recommend-ui .bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}
#iris-recommend-ui .bs-tooltip-left,
.bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem;
}
#iris-recommend-ui .bs-tooltip-left .arrow,
.bs-tooltip-auto[x-placement^="left"] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
#iris-recommend-ui .bs-tooltip-left .arrow::before,
.bs-tooltip-auto[x-placement^="left"] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}
#iris-recommend-ui .tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}
#iris-recommend-ui .rec-arrow-left,
#iris-recommend-ui .rec-arrow-right,
#iris-recommend-ui .rec-arrow-down,
#iris-recommend-ui .rec-arrow-up {
  width: 35px !important;
  height: 35px !important;
  line-height: 0px !important;
  min-width: 35px !important;
  color: rgb(103 58 183 / 0%) !important;
  background-position-x: center;
  background-position-y: center;
  background-size: 60% 100%;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-repeat: no-repeat;
  box-shadow: 0 2px 15px rgb(36 38 38 / 36%) !important;
}
#iris-recommend-ui .rec-arrow-left {
  position: absolute !important;
  left: -3% !important;
}
#iris-recommend-ui .rec-arrow-right {
  position: absolute !important;
  right: -3% !important;
}
#iris-recommend-ui .text-left.disabled,
#iris-recommend-ui .text-right.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
#iris-recommend-ui .rec-item-wrapper {
  height: 100% !important;
  /* box-sizing: unset !important; */
}
#iris-recommend-ui .one-by-one {
  width: 100%;
  display: flex;
  justify-content: center;
}
#iris-recommend-ui .position-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#iris-recommend-ui .scroll-top-bottom .carousel-control-prev {
  position: absolute !important;
  left: 53% !important;
  top: -60px !important;
}
#iris-recommend-ui
  .scroll-top-bottom
  .carousel-control-prev
  .carousel-control-prev-icon {
  top: 0 !important;
  transform: rotate(90deg) !important;
}
#iris-recommend-ui .scroll-top-bottom .carousel-control-next {
  position: absolute !important;
  right: 53% !important;
  bottom: -20px !important;
}
#iris-recommend-ui
  .scroll-top-bottom
  .carousel-control-next
  .carousel-control-next-icon {
  bottom: 0 !important;
  transform: rotate(90deg) !important;
}
#iris-recommend-ui .iiris-disable_center_buttons .rec-arrow-up,
#iris-recommend-ui .iiris-disable_center_buttons .rec-arrow-down,
#iris-recommend-ui .iiris-disable_center_buttons .rec-arrow-left,
#iris-recommend-ui .iiris-disable_center_buttons .rec-arrow-right {
  visibility: hidden;
}

.iiris-people-type .one-by-one,
.iiris-people-type .iiris-carousel-container-items {
  padding: 1px;
}

.iiris-people-type .one-by-one .iiris-col-sm,
.iiris-people-type .iiris-carousel-container-items {
  padding: 5px !important;
}

.iiris-people-type .iiris-card {
  box-shadow: 0px 1px 5px 1px #0202021f;
  border-radius: 0.5rem !important;
}

.iris-close-btn {
  position: absolute;
  right: 0;
  margin: 4px;
  z-index: 10;
  margin-left: -1rem;
  width: 1.4rem;
  height: 1.4rem;
  cursor: pointer;
  border-radius: 50%;
  border: 0.2rem solid;
}

.a-none {
  color: inherit !important;
  text-decoration: none !important;
  height: 100%;
}

.iiris-popup-overlay {
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: 100000;
}

.iiris-popup-footer {
  text-align: center;
  margin: 8px 0;
}

.iiris-popup-body img {
  width: 100%;
  height: 100%;
}

.iiris-popup-body a {
  width: 100%;
}

.content-heading {
  font-weight: 600;
  line-height: 1.5em;
}

.content-description {
  font-weight: 400;
  line-height: 1.5em;
}

.video-tag {
  padding: 0.2rem;
  border: 1px solid black;
  margin: 4px;
  border-radius: 4rem;
  font-weight: 500;
  font-size: 14px;
  transition-duration: 0.3s;
}

.video-tag:hover {
  color: white;
  background: #1d2d35;
  border-color: #1d2d35;
}

.video-col-container {
  border: none !important;
  border-radius: 0 !important;
}

.video-img-container {
  background: none !important;
}

.grid-video-vertical .grid-vertical-content {
  padding: 1rem 0 0 1rem;
}

.hover-underline:hover {
  text-decoration: underline;
}

.iiris-video-type {
  padding: 25px 0 0 0;
}

.grid-video-vertical:hover .play-button {
  display: block;
  opacity: 1;
}

.grid-video-vertical:hover .play-button img {
  width: 50px;
  height: 50px;
}

.grid-video-vertical:hover .video-insights {
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  height: 2rem;
  padding: 2px;
  background: white;
  opacity: 1;
}

.grid-video-vertical:hover .pointer {
  cursor: pointer;
}

.grid-video-vertical:hover .video-img-container {
  opacity: 0.7;
  position: relative;
}

.recommended-products ol li {
  list-style-type: decimal !important;
}

.lazy-load-image-background.lazy-load-image-loaded {
  width: 100%;
}

.no-image {
  color: #c82333;
}

.iiris-popup-body {
  overflow: hidden;
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
}

.html-body {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/lib/components/iris-recommend.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;GAWG;AACH;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB;;;;gCAI8B;AAChC;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,UAAU;EACV,gDAAgD;AAClD;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,+CAA+C;AACjD;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,+CAA+C;AACjD;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C;AAChD;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;;;EAKE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;;;EAKE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;EAKE,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,cAAc;EACd,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,iBAAiB;AACnB;AACA;;;;;;;EAOE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;;;;;;EAQE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;;;EAIE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,oBAAoB;EACpB,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;;;;;;;;;;;;;EAcE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,gCAAgC;AAClC;AACA;;;;;;;;;;;;EAYE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,kCAAkC;AACpC;AACA;;;;;;;;;;;;EAYE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;;;;;;;EAqBE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;;;;;;;;;;;;;;;;;;;;EAqBE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB;;gCAE8B;AAChC;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,yBAAyB;EACzB,UAAU;AACZ;AACA;;;;EAIE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;EAGE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,sBAAsB;AACxB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,oCAAoC;EACpC,yDAAiR;EACjR,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;AACA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;EAEE,oCAAoC;EACpC;6BAC2B;AAC7B;AACA;;EAEE,qBAAqB;EACrB,oCAAoC;EACpC,yDAA4U;EAC5U,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;AACA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;EAEE,oCAAoC;EACpC;6BAC2B;AAC7B;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;;IAEE,0BAA0B;IAC1B,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;EAME,aAAa;EACb,qBAAqB;AACvB;AACA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;;;;;EAKE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE;;;IAGE,gBAAgB;EAClB;AACF;AACA;EACE;;;;IAIE,gBAAgB;EAClB;AACF;AACA;EACE;;;;;IAKE,iBAAiB;EACnB;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAuEE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;;IAEE,0BAA0B;IAC1B,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA;;EAEE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;EAKE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,gDAAgD;AAClD;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;;;;EAKE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,oCAAoC;EACpC,yDAA4U;EAC5U,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;AACA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;EAEE,oCAAoC;EACpC;6BAC2B;AAC7B;AACA;;EAEE,qBAAqB;EACrB,uCAAuC;EACvC;;;;;6BAK2B;AAC7B;AACA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;;EAOE,qBAAqB;AACvB;AACA;;;;;;;EAOE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;;;;;;EAOE,gDAAgD;AAClD;AACA;;;;;;;EAOE,qBAAqB;AACvB;AACA;;;;;EAKE,qBAAqB;AACvB;AACA;;;;;EAKE,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;EAqBE,iBAAiB;AACnB;AACA;;;;;;;EAOE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;;;;;;EAQE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;;;EAIE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,oBAAoB;EACpB,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;;;;;;;;;;;;;EAcE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,gCAAgC;AAClC;AACA;;;;;;;;;;;;EAYE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,kCAAkC;AACpC;AACA;;;;;;;;;;;;;;;EAeE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;EACnB,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;;EAEE,sBAAsB;EACtB,+CAA+C;EAC/C,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;AAC/C;AACA;EACE,0DAA0D;AAC5D;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,0CAA0C;AAC5C;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;EACpB,cAAc;EACd,WAAW;AACb;AACA;;EAEE,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;;EAEE,+CAA+C;EAC/C,8CAA8C;AAChD;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE;IACE,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;EACA;;IAEE,cAAc;IACd,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;;;;;;;;IAQE,0BAA0B;EAC5B;EACA;;;;;;;;IAQE,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;;;;;;;;IAQE,yBAAyB;EAC3B;EACA;;;;;;;;IAQE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;IACnB,UAAU;IACV,SAAS;EACX;EACA;;IAEE,qBAAqB;IACrB,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB;;2CAEyC;EACzC,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;EAGE;;;gCAG8B;AAChC;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,2BAA2B;EAC3B,8CAA8C;EAC9C,sCAAsC;EACtC;;sCAEoC;AACtC;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,mCAAmC;EACnC,2BAA2B;AAC7B;AACA;;EAEE,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;AACjB;AACA;;;EAGE,UAAU;EACV,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;;;;EAIE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;AACA;EACE,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,QAAQ;EACR,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;;;;;;;;;;EAUE,qDAAqD;EACrD,oCAAoC;AACtC;AACA;;;;EAIE,YAAY;AACd;AACA;;EAEE,yDAAmM;AACrM;AACA;;EAEE,yDAAmM;AACrM;AACA;EACE,yDAAmM;EACnM,oCAAoC;EACpC,4CAA4C;EAC5C,yCAAyC;EACzC,uCAAuC;EACvC,wCAAwC;EACxC,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,kCAAkC;EAClC,yDAAmM;AACrM;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,qCAAqC;EACrC,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB;;2DAEyD;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;AACzC;AACA;;EAEE,SAAS;EACT,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,MAAM;EACN,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,gCAAgC;AAClC;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,sCAAsC;AACxC;AACA;;EAEE,UAAU;EACV,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,SAAS;EACT;;2DAEyD;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,MAAM;EACN,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,OAAO;EACP,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,MAAM;AACR;AACA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,OAAO;EACP,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;;;;EAIE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,sCAAsC;EACtC,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,wBAAwB;EACxB,4BAA4B;EAC5B,qDAAqD;AACvD;AACA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;;;EAIE,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;;;;EAIE,oBAAoB;EACpB,mCAAmC;AACrC;AACA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["#iris-recommend {\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.iris-recommend {\n  margin: 1px auto;\n}\n\n#iris-recommend-ui #carousel_container {\n  overflow: visible;\n}\n\n/* body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #fff;\n} */\n#iris-recommend-ui .iiris-btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #212529;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition:\n    color 0.15s ease-in-out,\n    background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  #iris-recommend-ui .iiris-btn {\n    transition: none;\n  }\n}\n#iris-recommend-ui .iiris-btn:hover {\n  color: #212529;\n  text-decoration: none;\n}\n#iris-recommend-ui .iiris-btn.focus,\n#iris-recommend-ui .iiris-btn:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n#iris-recommend-ui .iiris-btn.disabled,\n#iris-recommend-ui .iiris-btn:disabled {\n  opacity: 0.65;\n}\n#iris-recommend-ui .iiris-btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n#iris-recommend-ui a.iiris-btn.disabled,\n#iris-recommend-ui fieldset:disabled a.iiris-btn {\n  pointer-events: none;\n}\n#iris-recommend-ui .iiris-btn-primary {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n#iris-recommend-ui .iiris-btn-primary:hover {\n  color: #fff;\n  background-color: #0069d9;\n  border-color: #0062cc;\n}\n#iris-recommend-ui .iiris-btn-primary.focus,\n#iris-recommend-ui .iiris-btn-primary:focus {\n  color: #fff;\n  background-color: #0069d9;\n  border-color: #0062cc;\n  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n}\n#iris-recommend-ui .iiris-btn-primary.disabled,\n#iris-recommend-ui .iiris-btn-primary:disabled {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n#iris-recommend-ui .iiris-btn-primary:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-primary:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #0062cc;\n  border-color: #005cbf;\n}\n#iris-recommend-ui\n  .iiris-btn-primary:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-primary:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n}\n#iris-recommend-ui .iiris-btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n#iris-recommend-ui .iiris-btn-secondary:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n#iris-recommend-ui .iiris-btn-secondary.focus,\n#iris-recommend-ui .iiris-btn-secondary:focus {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);\n}\n#iris-recommend-ui .iiris-btn-secondary.disabled,\n#iris-recommend-ui .iiris-btn-secondary:disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n#iris-recommend-ui .iiris-btn-secondary:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-secondary:not(:disabled):not(.disabled):active,\n.show > .iiris-btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #545b62;\n  border-color: #4e555b;\n}\n#iris-recommend-ui\n  .iiris-btn-secondary:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-secondary:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);\n}\n#iris-recommend-ui .iiris-btn-success {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n#iris-recommend-ui .iiris-btn-success:hover {\n  color: #fff;\n  background-color: #218838;\n  border-color: #1e7e34;\n}\n#iris-recommend-ui .iiris-btn-success.focus,\n#iris-recommend-ui .iiris-btn-success:focus {\n  color: #fff;\n  background-color: #218838;\n  border-color: #1e7e34;\n  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);\n}\n#iris-recommend-ui .iiris-btn-success.disabled,\n#iris-recommend-ui .iiris-btn-success:disabled {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n#iris-recommend-ui .iiris-btn-success:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-success:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: #1e7e34;\n  border-color: #1c7430;\n}\n#iris-recommend-ui\n  .iiris-btn-success:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-success:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);\n}\n#iris-recommend-ui .iiris-btn-info {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n#iris-recommend-ui .iiris-btn-info:hover {\n  color: #fff;\n  background-color: #138496;\n  border-color: #117a8b;\n}\n#iris-recommend-ui .iiris-btn-info.focus,\n#iris-recommend-ui .iiris-btn-info:focus {\n  color: #fff;\n  background-color: #138496;\n  border-color: #117a8b;\n  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);\n}\n#iris-recommend-ui .iiris-btn-info.disabled,\n#iris-recommend-ui .iiris-btn-info:disabled {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n#iris-recommend-ui .iiris-btn-info:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-info:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: #117a8b;\n  border-color: #10707f;\n}\n#iris-recommend-ui .iiris-btn-info:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui .iiris-btn-info:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);\n}\n#iris-recommend-ui .iiris-btn-warning {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n#iris-recommend-ui .iiris-btn-warning:hover {\n  color: #212529;\n  background-color: #e0a800;\n  border-color: #d39e00;\n}\n#iris-recommend-ui .iiris-btn-warning.focus,\n#iris-recommend-ui .iiris-btn-warning:focus {\n  color: #212529;\n  background-color: #e0a800;\n  border-color: #d39e00;\n  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);\n}\n#iris-recommend-ui .iiris-btn-warning.disabled,\n#iris-recommend-ui .iiris-btn-warning:disabled {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n#iris-recommend-ui .iiris-btn-warning:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-warning:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #d39e00;\n  border-color: #c69500;\n}\n#iris-recommend-ui\n  .iiris-btn-warning:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-warning:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);\n}\n#iris-recommend-ui .iiris-btn-danger {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n#iris-recommend-ui .iiris-btn-danger:hover {\n  color: #fff;\n  background-color: #c82333;\n  border-color: #bd2130;\n}\n#iris-recommend-ui .iiris-btn-danger.focus,\n#iris-recommend-ui .iiris-btn-danger:focus {\n  color: #fff;\n  background-color: #c82333;\n  border-color: #bd2130;\n  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);\n}\n#iris-recommend-ui .iiris-btn-danger.disabled,\n#iris-recommend-ui .iiris-btn-danger:disabled {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n#iris-recommend-ui .iiris-btn-danger:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-danger:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #bd2130;\n  border-color: #b21f2d;\n}\n#iris-recommend-ui .iiris-btn-danger:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui .iiris-btn-danger:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);\n}\n#iris-recommend-ui .iiris-btn-light {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n#iris-recommend-ui .iiris-btn-light:hover {\n  color: #212529;\n  background-color: #e2e6ea;\n  border-color: #dae0e5;\n}\n#iris-recommend-ui .iiris-btn-light.focus,\n#iris-recommend-ui .iiris-btn-light:focus {\n  color: #212529;\n  background-color: #e2e6ea;\n  border-color: #dae0e5;\n  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);\n}\n#iris-recommend-ui .iiris-btn-light.disabled,\n#iris-recommend-ui .iiris-btn-light:disabled {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n#iris-recommend-ui .iiris-btn-light:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-light:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-light.dropdown-toggle {\n  color: #212529;\n  background-color: #dae0e5;\n  border-color: #d3d9df;\n}\n#iris-recommend-ui .iiris-btn-light:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui .iiris-btn-light:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);\n}\n#iris-recommend-ui .iiris-btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n#iris-recommend-ui .iiris-btn-dark:hover {\n  color: #fff;\n  background-color: #23272b;\n  border-color: #1d2124;\n}\n#iris-recommend-ui .iiris-btn-dark.focus,\n#iris-recommend-ui .iiris-btn-dark:focus {\n  color: #fff;\n  background-color: #23272b;\n  border-color: #1d2124;\n  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);\n}\n#iris-recommend-ui .iiris-btn-dark.disabled,\n#iris-recommend-ui .iiris-btn-dark:disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n#iris-recommend-ui .iiris-btn-dark:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-dark:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #1d2124;\n  border-color: #171a1d;\n}\n#iris-recommend-ui .iiris-btn-dark:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui .iiris-btn-dark:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-primary {\n  color: #007bff;\n  border-color: #007bff;\n}\n#iris-recommend-ui .iiris-btn-outline-primary:hover {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n#iris-recommend-ui .iiris-btn-outline-primary.focus,\n#iris-recommend-ui .iiris-btn-outline-primary:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-primary.disabled,\n#iris-recommend-ui .iiris-btn-outline-primary:disabled {\n  color: #007bff;\n  background-color: transparent;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-primary:not(:disabled):not(.disabled).active,\n#iris-recommend-ui\n  .iiris-btn-outline-primary:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-outline-primary:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n#iris-recommend-ui .iiris-btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n#iris-recommend-ui .iiris-btn-outline-secondary.focus,\n#iris-recommend-ui .iiris-btn-outline-secondary:focus {\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-secondary.disabled,\n#iris-recommend-ui .iiris-btn-outline-secondary:disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-secondary:not(:disabled):not(.disabled).active,\n#iris-recommend-ui\n  .iiris-btn-outline-secondary:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-outline-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-outline-secondary:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-success {\n  color: #28a745;\n  border-color: #28a745;\n}\n#iris-recommend-ui .iiris-btn-outline-success:hover {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n#iris-recommend-ui .iiris-btn-outline-success.focus,\n#iris-recommend-ui .iiris-btn-outline-success:focus {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-success.disabled,\n#iris-recommend-ui .iiris-btn-outline-success:disabled {\n  color: #28a745;\n  background-color: transparent;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-success:not(:disabled):not(.disabled).active,\n#iris-recommend-ui\n  .iiris-btn-outline-success:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-success:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-outline-success:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-info {\n  color: #17a2b8;\n  border-color: #17a2b8;\n}\n#iris-recommend-ui .iiris-btn-outline-info:hover {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n#iris-recommend-ui .iiris-btn-outline-info.focus,\n#iris-recommend-ui .iiris-btn-outline-info:focus {\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-info.disabled,\n#iris-recommend-ui .iiris-btn-outline-info:disabled {\n  color: #17a2b8;\n  background-color: transparent;\n}\n#iris-recommend-ui .iiris-btn-outline-info:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-outline-info:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-info:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-outline-info:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-warning {\n  color: #ffc107;\n  border-color: #ffc107;\n}\n#iris-recommend-ui .iiris-btn-outline-warning:hover {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n#iris-recommend-ui .iiris-btn-outline-warning.focus,\n#iris-recommend-ui .iiris-btn-outline-warning:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-warning.disabled,\n#iris-recommend-ui .iiris-btn-outline-warning:disabled {\n  color: #ffc107;\n  background-color: transparent;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-warning:not(:disabled):not(.disabled).active,\n#iris-recommend-ui\n  .iiris-btn-outline-warning:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-outline-warning:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-danger {\n  color: #dc3545;\n  border-color: #dc3545;\n}\n#iris-recommend-ui .iiris-btn-outline-danger:hover {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n#iris-recommend-ui .iiris-btn-outline-danger.focus,\n#iris-recommend-ui .iiris-btn-outline-danger:focus {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-danger.disabled,\n#iris-recommend-ui .iiris-btn-outline-danger:disabled {\n  color: #dc3545;\n  background-color: transparent;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-danger:not(:disabled):not(.disabled).active,\n#iris-recommend-ui\n  .iiris-btn-outline-danger:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-outline-danger:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-light {\n  color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n#iris-recommend-ui .iiris-btn-outline-light:hover {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n#iris-recommend-ui .iiris-btn-outline-light.focus,\n#iris-recommend-ui .iiris-btn-outline-light:focus {\n  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-light.disabled,\n#iris-recommend-ui .iiris-btn-outline-light:disabled {\n  color: #f8f9fa;\n  background-color: transparent;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-light:not(:disabled):not(.disabled).active,\n#iris-recommend-ui\n  .iiris-btn-outline-light:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-outline-light.dropdown-toggle {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-light:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-outline-light:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n#iris-recommend-ui .iiris-btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n#iris-recommend-ui .iiris-btn-outline-dark.focus,\n#iris-recommend-ui .iiris-btn-outline-dark:focus {\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n#iris-recommend-ui .iiris-btn-outline-dark.disabled,\n#iris-recommend-ui .iiris-btn-outline-dark:disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n#iris-recommend-ui .iiris-btn-outline-dark:not(:disabled):not(.disabled).active,\n#iris-recommend-ui .iiris-btn-outline-dark:not(:disabled):not(.disabled):active,\n#iris-recommend-ui .show > .iiris-btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n#iris-recommend-ui\n  .iiris-btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n#iris-recommend-ui\n  .iiris-btn-outline-dark:not(:disabled):not(.disabled):active:focus,\n#iris-recommend-ui .show > .iiris-btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n#iris-recommend-ui .iiris-btn-link {\n  font-weight: 400;\n  color: #007bff;\n  text-decoration: none;\n}\n#iris-recommend-ui .iiris-btn-link:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n#iris-recommend-ui .iiris-btn-link.focus,\n#iris-recommend-ui .iiris-btn-link:focus {\n  text-decoration: underline;\n}\n#iris-recommend-ui .iiris-btn-link.disabled,\n#iris-recommend-ui .iiris-btn-link:disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n#iris-recommend-ui .iiris-btn-group-lg > .iiris-btn,\n#iris-recommend-ui .iiris-btn-lg {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n#iris-recommend-ui .iiris-btn-group-sm > .iiris-btn,\n#iris-recommend-ui .iiris-btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n#iris-recommend-ui .iiris-btn-block {\n  display: block;\n  width: 100%;\n}\n#iris-recommend-ui .iiris-btn-block + .iiris-btn-block {\n  margin-top: 0.5rem;\n}\n#iris-recommend-ui input[type=\"button\"].iiris-btn-block,\n#iris-recommend-ui input[type=\"reset\"].iiris-btn-block,\n#iris-recommend-ui input[type=\"submit\"].iiris-iiris-btn-block {\n  width: 100%;\n}\n#iris-recommend-ui .iiris-btn-block {\n  display: block;\n  width: 100%;\n}\n#iris-recommend-ui .iiris-btn-block + .iiris-btn-block {\n  margin-top: 0.5rem;\n}\n#iris-recommend-ui input[type=\"button\"].iiris-btn-block,\n#iris-recommend-ui input[type=\"reset\"].iiris-btn-block,\n#iris-recommend-ui input[type=\"submit\"].iiris-btn-block {\n  width: 100%;\n}\n#iris-recommend-ui .iiris-text-center {\n  text-align: center !important;\n}\n#iris-recommend-ui .iiris-input-group {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%;\n}\n#iris-recommend-ui .iiris-input-group > .custom-file,\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group > .iiris-form-control,\n#iris-recommend-ui .iiris-input-group > .form-control-plaintext {\n  position: relative;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  margin-bottom: 0;\n}\n#iris-recommend-ui .iiris-input-group > .custom-file + .custom-file,\n#iris-recommend-ui .iiris-input-group > .custom-file + .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group > .custom-file + .iiris-form-control,\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select + .custom-file,\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-custom-select\n  + .iiris-custom-select,\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-custom-select\n  + .iiris-form-control,\n#iris-recommend-ui .iiris-input-group > .form-control + .custom-file,\n#iris-recommend-ui .iiris-input-group > .form-control + .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group > .form-control + .form-control,\n#iris-recommend-ui .iiris-input-group > .form-control-plaintext + .custom-file,\n#iris-recommend-ui\n  .iiris-input-group\n  > .form-control-plaintext\n  + .iiris-custom-select,\n#iris-recommend-ui\n  .iiris-input-group\n  > .form-control-plaintext\n  + .form-control {\n  margin-left: -1px;\n}\n#iris-recommend-ui\n  .iiris-input-group\n  > .custom-file\n  .custom-file-input:focus\n  ~ .custom-file-label,\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select:focus,\n#iris-recommend-ui .iiris-input-group > .iiris-form-control:focus {\n  z-index: 3;\n}\n#iris-recommend-ui .iiris-input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select:not(:last-child),\n#iris-recommend-ui .iiris-input-group > .iiris-form-control:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select:not(:first-child),\n#iris-recommend-ui .iiris-input-group > .iiris-form-control:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n#iris-recommend-ui .iiris-input-group > .custom-file {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n#iris-recommend-ui\n  .iiris-input-group\n  > .custom-file:not(:last-child)\n  .custom-file-label,\n#iris-recommend-ui\n  .iiris-input-group\n  > .custom-file:not(:last-child)\n  .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n#iris-recommend-ui\n  .iiris-input-group\n  > .custom-file:not(:first-child)\n  .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n#iris-recommend-ui .iiris-input-group-append,\n#iris-recommend-ui .iiris-input-group-prepend {\n  display: -ms-flexbox;\n  display: flex;\n}\n#iris-recommend-ui .iiris-input-group-append .btn,\n#iris-recommend-ui .iiris-input-group-prepend .btn {\n  position: relative;\n  z-index: 2;\n}\n#iris-recommend-ui .iiris-input-group-append .btn:focus,\n#iris-recommend-ui .iiris-input-group-prepend .btn:focus {\n  z-index: 3;\n}\n#iris-recommend-ui .iiris-input-group-append .btn + .btn,\n#iris-recommend-ui .iiris-input-group-append .btn + .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-append .iiris-input-group-text + .btn,\n#iris-recommend-ui\n  .iiris-input-group-append\n  .iiris-input-group-text\n  + .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-prepend .btn + .btn,\n#iris-recommend-ui .iiris-input-group-prepend .btn + .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-prepend .iiris-input-group-text + .btn,\n#iris-recommend-ui\n  .iiris-input-group-prepend\n  .iiris-input-group-text\n  + .iiris-input-group-text {\n  margin-left: -1px;\n}\n#iris-recommend-ui .iiris-input-group-prepend {\n  margin-right: -1px;\n}\n#iris-recommend-ui .iiris-input-group-append {\n  margin-left: -1px;\n}\n#iris-recommend-ui .iiris-input-group-text {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n#iris-recommend-ui .iiris-input-group-text input[type=\"checkbox\"],\n#iris-recommend-ui .iiris-input-group-text input[type=\"radio\"] {\n  margin-top: 0;\n}\n#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group-lg > .form-control:not(textarea) {\n  height: calc(1.5em + 1rem + 2px);\n}\n#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group-lg > .form-control,\n#iris-recommend-ui .iiris-input-group-lg > .iiris-input-group-append > .btn,\n#iris-recommend-ui\n  .iiris-input-group-lg\n  > .iiris-input-group-append\n  > .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-lg > .iiris-input-group-prepend > .btn,\n#iris-recommend-ui\n  .iiris-input-group-lg\n  > .iiris-input-group-prepend\n  > .iiris-input-group-text {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n#iris-recommend-ui .iiris-input-group-sm > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group-sm > .form-control:not(textarea) {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n#iris-recommend-ui .iiris-input-group-sm > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group-sm > .form-control,\n#iris-recommend-ui .iiris-input-group-sm > .iiris-input-group-append > .btn,\n#iris-recommend-ui\n  .iiris-input-group-sm\n  > .iiris-input-group-append\n  > .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-sm > .iiris-input-group-prepend > .btn,\n#iris-recommend-ui\n  .iiris-input-group-sm\n  > .iiris-input-group-prepend\n  > .iiris-input-group-text {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group-sm > .iiris-custom-select {\n  padding-right: 1.75rem;\n}\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-append:last-child\n  > .btn:not(:last-child):not(.dropdown-toggle),\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-append:last-child\n  > .iiris-input-group-text:not(:last-child),\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-append:not(:last-child)\n  > .btn,\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-append:not(:last-child)\n  > .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group > .iiris-input-group-prepend > .btn,\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-prepend\n  > .iiris-input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n#iris-recommend-ui .iiris-input-group > .iiris-input-group-append > .btn,\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-append\n  > .iiris-input-group-text,\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-prepend:first-child\n  > .btn:not(:first-child),\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-prepend:first-child\n  > .iiris-input-group-text:not(:first-child),\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-prepend:not(:first-child)\n  > .btn,\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-input-group-prepend:not(:first-child)\n  > .iiris-input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n#iris-recommend-ui .iiris-form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition:\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  #iris-recommend-ui .iiris-form-control {\n    transition: none;\n  }\n}\n#iris-recommend-ui .iiris-form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n#iris-recommend-ui .iiris-form-control:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057;\n}\n#iris-recommend-ui .iiris-form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n#iris-recommend-ui .iiris-form-control::-webkit-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n#iris-recommend-ui .iiris-form-control::-moz-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n#iris-recommend-ui .iiris-form-control:-ms-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n#iris-recommend-ui .iiris-form-control::-ms-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n#iris-recommend-ui .iiris-form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n#iris-recommend-ui .iiris-form-control:disabled,\n#iris-recommend-ui .iiris-form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n#iris-recommend-ui input[type=\"date\"].iiris-form-control,\n#iris-recommend-ui input[type=\"datetime-local\"].iiris-form-control,\n#iris-recommend-ui input[type=\"month\"].iiris-form-control,\n#iris-recommend-ui input[type=\"time\"].iiris-form-control {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n#iris-recommend-ui select.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n#iris-recommend-ui .form-control-file,\n#iris-recommend-ui .form-control-range {\n  display: block;\n  width: 100%;\n}\n#iris-recommend-ui .iiris-col .widget-label {\n  -webkit-line-clamp: 1;\n  line-height: 24px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: inherit;\n}\n#iris-recommend-ui .iiris-col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n#iris-recommend-ui .iiris-col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n#iris-recommend-ui .iiris-col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n#iris-recommend-ui .form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n#iris-recommend-ui .form-control-plaintext.form-control-lg,\n#iris-recommend-ui .form-control-plaintext.form-control-sm {\n  padding-right: 0;\n  padding-left: 0;\n}\n#iris-recommend-ui .form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n#iris-recommend-ui .form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n#iris-recommend-ui select.form-control[multiple],\n#iris-recommend-ui select.form-control[size] {\n  height: auto;\n}\n#iris-recommend-ui textarea.form-control {\n  height: auto;\n}\n#iris-recommend-ui .iiris-form-group {\n  margin-bottom: 1rem;\n}\n#iris-recommend-ui .form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n#iris-recommend-ui .iiris-form-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n#iris-recommend-ui .iiris-form-row > .iiris-col,\n#iris-recommend-ui .col,\n#iris-recommend-ui .iiris-form-row > [class*=\"col-\"] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n#iris-recommend-ui .iiris-form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n#iris-recommend-ui .iiris-form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n#iris-recommend-ui .iiris-form-check-input:disabled ~ .iiris-form-check-label,\n#iris-recommend-ui .iiris-form-check-input[disabled] ~ .iiris-form-check-label {\n  color: #6c757d;\n}\n#iris-recommend-ui .iiris-form-check-label {\n  margin-bottom: 0;\n}\n#iris-recommend-ui .iiris-form-check-inline {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n#iris-recommend-ui .iiris-form-check-inline .iiris-form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n#iris-recommend-ui .valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #28a745;\n}\n#iris-recommend-ui .valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(40, 167, 69, 0.9);\n  border-radius: 0.25rem;\n}\n#iris-recommend-ui .is-valid ~ .valid-feedback,\n#iris-recommend-ui .is-valid ~ .valid-tooltip,\n#iris-recommend-ui .was-validated :valid ~ .valid-feedback,\n#iris-recommend-ui .was-validated :valid ~ .valid-tooltip {\n  display: block;\n}\n#iris-recommend-ui .iiris-form-control.is-valid,\n#iris-recommend-ui .was-validated .iiris-form-control:valid {\n  border-color: #28a745;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n#iris-recommend-ui .iiris-form-control.is-valid:focus,\n#iris-recommend-ui .was-validated .iiris-form-control:valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n#iris-recommend-ui .was-validated textarea.form-control:valid,\n#iris-recommend-ui textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right\n    calc(0.375em + 0.1875rem);\n}\n#iris-recommend-ui .iiris-form-control.is-invalid,\n#iris-recommend-ui .was-validated .iiris-form-control:invalid {\n  border-color: #dc3545;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n#iris-recommend-ui .iiris-form-control.is-invalid:focus,\n#iris-recommend-ui .was-validated .iiris-form-control:invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n#iris-recommend-ui .was-validated textarea.form-control:invalid,\n#iris-recommend-ui textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right\n    calc(0.375em + 0.1875rem);\n}\n#iris-recommend-ui .iiris-col-sm,\n#iris-recommend-ui .col-sm {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n@media (min-width: 576px) {\n  #iris-recommend-ui .iiris-col-sm,\n  #iris-recommend-ui .col-sm {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%;\n  }\n}\n#iris-recommend-ui .iiris-clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n#iris-recommend-ui dl,\n#iris-recommend-ui ol,\n#iris-recommend-ui ul {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n#iris-recommend-ui ol ol,\n#iris-recommend-ui ol ul,\n#iris-recommend-ui ul ol,\n#iris-recommend-ui ul ul {\n  margin-bottom: 0;\n}\n#iris-recommend-ui svg {\n  overflow: hidden;\n  vertical-align: middle;\n}\n#iris-recommend-ui a {\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent;\n}\n#iris-recommend-ui a:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n#iris-recommend-ui a:not([href]) {\n  color: inherit;\n  text-decoration: none;\n}\n#iris-recommend-ui a:not([href]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n#iris-recommend-ui h1,\n#iris-recommend-ui h2,\n#iris-recommend-ui h3,\n#iris-recommend-ui h4,\n#iris-recommend-ui h5,\n#iris-recommend-ui h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n#iris-recommend-ui .h1,\n#iris-recommend-ui .h2,\n#iris-recommend-ui .h3,\n#iris-recommend-ui .h4,\n#iris-recommend-ui .h5,\n#iris-recommend-ui .h6,\n#iris-recommend-ui #iris-recommend-ui h1,\n#iris-recommend-ui h2,\n#iris-recommend-ui h3,\n#iris-recommend-ui h4,\n#iris-recommend-ui h5,\n#iris-recommend-ui h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n#iris-recommend-ui .h1,\n#iris-recommend-ui h1 {\n  font-size: 2.5rem;\n}\n#iris-recommend-ui .h2,\n#iris-recommend-ui h2 {\n  font-size: 2rem;\n}\n#iris-recommend-ui .h3,\n#iris-recommend-ui h3 {\n  font-size: 1.75rem;\n}\n#iris-recommend-ui .h4,\n#iris-recommend-ui h4 {\n  font-size: 1.5rem;\n}\n#iris-recommend-ui .h5,\n#iris-recommend-ui h5 {\n  font-size: 1.25rem;\n}\n#iris-recommend-ui .h6,\n#iris-recommend-ui h6 {\n  font-size: 1rem;\n}\n#iris-recommend-ui p {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n#iris-recommend-ui .iiris-container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 576px) {\n  #iris-recommend-ui .iiris-container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  #iris-recommend-ui .iiris-container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  #iris-recommend-ui .iiris-container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  #iris-recommend-ui .iiris-container {\n    max-width: 1140px;\n  }\n}\n#iris-recommend-ui .iiris-container-fluid,\n#iris-recommend-ui .iiris-container-lg,\n#iris-recommend-ui .iiris-container-md,\n#iris-recommend-ui .iiris-container-sm,\n#iris-recommend-ui .iiris-container-xl {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 576px) {\n  #iris-recommend-ui .iiris-container,\n  #iris-recommend-ui .iiris-container-sm {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  #iris-recommend-ui .iiris-container,\n  #iris-recommend-ui .iiris-container-md,\n  #iris-recommend-ui .iiris-container-sm {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  #iris-recommend-ui .iiris-container,\n  #iris-recommend-ui .iiris-container-lg,\n  #iris-recommend-ui .iiris-container-md,\n  #iris-recommend-ui .iiris-container-sm {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  #iris-recommend-ui .iiris-container,\n  #iris-recommend-ui .iiris-container-lg,\n  #iris-recommend-ui .iiris-container-md,\n  #iris-recommend-ui .iiris-container-sm,\n  #iris-recommend-ui .iiris-container-xl {\n    max-width: 1140px;\n  }\n}\n#iris-recommend-ui .iiris-col,\n#iris-recommend-ui .col,\n#iris-recommend-ui .iiris-col-1,\n#iris-recommend-ui .iiris-col-10,\n#iris-recommend-ui .iiris-col-11,\n#iris-recommend-ui .iiris-col-12,\n#iris-recommend-ui .iiris-col-2,\n#iris-recommend-ui .iiris-col-3,\n#iris-recommend-ui .iiris-col-4,\n#iris-recommend-ui .iiris-col-5,\n#iris-recommend-ui .iiris-col-6,\n#iris-recommend-ui .iiris-col-7,\n#iris-recommend-ui .iiris-col-8,\n#iris-recommend-ui .iiris-col-9,\n#iris-recommend-ui .iiris-col-auto,\n#iris-recommend-ui .iiris-col-lg,\n#iris-recommend-ui .iiris-col-lg-1,\n#iris-recommend-ui .iiris-col-lg-10,\n#iris-recommend-ui .iiris-col-lg-11,\n#iris-recommend-ui .iiris-col-lg-12,\n#iris-recommend-ui .iiris-col-lg-2,\n#iris-recommend-ui .iiris-col-lg-3,\n#iris-recommend-ui .iiris-col-lg-4,\n#iris-recommend-ui .iiris-col-lg-5,\n#iris-recommend-ui .iiris-col-lg-6,\n#iris-recommend-ui .iiris-col-lg-7,\n#iris-recommend-ui .iiris-col-lg-8,\n#iris-recommend-ui .iiris-col-lg-9,\n#iris-recommend-ui .iiris-col-lg-auto,\n#iris-recommend-ui .iiris-col-md,\n#iris-recommend-ui .iiris-col-md-1,\n#iris-recommend-ui .iiris-col-md-10,\n#iris-recommend-ui .iiris-col-md-11,\n#iris-recommend-ui .iiris-col-md-12,\n#iris-recommend-ui .iiris-col-md-2,\n#iris-recommend-ui .iiris-col-md-3,\n#iris-recommend-ui .iiris-col-md-4,\n#iris-recommend-ui .iiris-col-md-5,\n#iris-recommend-ui .iiris-col-md-6,\n#iris-recommend-ui .iiris-col-md-7,\n#iris-recommend-ui .iiris-col-md-8,\n#iris-recommend-ui .iiris-col-md-9,\n#iris-recommend-ui .iiris-col-md-auto,\n#iris-recommend-ui .iiris-col-sm,\n#iris-recommend-ui .iiris-col-sm-1,\n#iris-recommend-ui .iiris-col-sm-10,\n#iris-recommend-ui .iiris-col-sm-11,\n#iris-recommend-ui .iiris-col-sm-12,\n#iris-recommend-ui .iiris-col-sm-2,\n#iris-recommend-ui .iiris-col-sm-3,\n#iris-recommend-ui .iiris-col-sm-4,\n#iris-recommend-ui .iiris-col-sm-5,\n#iris-recommend-ui .iiris-col-sm-6,\n#iris-recommend-ui .iiris-col-sm-7,\n#iris-recommend-ui .iiris-col-sm-8,\n#iris-recommend-ui .iiris-col-sm-9,\n#iris-recommend-ui .iiris-col-sm-auto,\n#iris-recommend-ui .iiris-col-xl,\n#iris-recommend-ui .iiris-col-xl-1,\n#iris-recommend-ui .iiris-col-xl-10,\n#iris-recommend-ui .iiris-col-xl-11,\n#iris-recommend-ui .iiris-col-xl-12,\n#iris-recommend-ui .iiris-col-xl-2,\n#iris-recommend-ui .iiris-col-xl-3,\n#iris-recommend-ui .iiris-col-xl-4,\n#iris-recommend-ui .iiris-col-xl-5,\n#iris-recommend-ui .iiris-col-xl-6,\n#iris-recommend-ui .iiris-col-xl-7,\n#iris-recommend-ui .iiris-col-xl-8,\n#iris-recommend-ui .iiris-col-xl-9,\n#iris-recommend-ui .iiris-col-xl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n#iris-recommend-ui .iiris-col,\n#iris-recommend-ui .col {\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  min-width: 0;\n  max-width: 100%;\n}\n#iris-recommend-ui .row-iris-cols-1 > * {\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n#iris-recommend-ui .row-iris-cols-2 > * {\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n#iris-recommend-ui .row-iris-cols-3 > * {\n  -ms-flex: 0 0 33.333333%;\n  flex: 0 0 33.333333%;\n  max-width: 33.333333%;\n}\n#iris-recommend-ui .row-iris-cols-4 > * {\n  -ms-flex: 0 0 25%;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n#iris-recommend-ui .row-iris-cols-5 > * {\n  -ms-flex: 0 0 20%;\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n#iris-recommend-ui .row-iris-cols-6 > * {\n  -ms-flex: 0 0 16.666667%;\n  flex: 0 0 16.666667%;\n  max-width: 16.666667%;\n}\n#iris-recommend-ui .iiris-col-auto {\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n#iris-recommend-ui .iiris-col-1,\n#iris-recommend-ui .col-1 {\n  -ms-flex: 0 0 8.333333%;\n  flex: 0 0 8.333333%;\n  max-width: 8.333333%;\n}\n#iris-recommend-ui .iiris-col-2,\n#iris-recommend-ui .col-2 {\n  -ms-flex: 0 0 16.666667%;\n  flex: 0 0 16.666667%;\n  max-width: 16.666667%;\n}\n#iris-recommend-ui .iiris-col-3,\n#iris-recommend-ui .col-3 {\n  -ms-flex: 0 0 25%;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n#iris-recommend-ui .iiris-col-4,\n#iris-recommend-ui .col-4 {\n  -ms-flex: 0 0 33.333333%;\n  flex: 0 0 33.333333%;\n  max-width: 33.333333%;\n}\n#iris-recommend-ui .iiris-col-5,\n#iris-recommend-ui .col-5 {\n  -ms-flex: 0 0 41.666667%;\n  flex: 0 0 41.666667%;\n  max-width: 41.666667%;\n}\n#iris-recommend-ui .iiris-col-6,\n#iris-recommend-ui .col-6 {\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n#iris-recommend-ui .iiris-col-7,\n#iris-recommend-ui .col-7 {\n  -ms-flex: 0 0 58.333333%;\n  flex: 0 0 58.333333%;\n  max-width: 58.333333%;\n}\n#iris-recommend-ui .iiris-col-8,\n#iris-recommend-ui .col-8 {\n  -ms-flex: 0 0 66.666667%;\n  flex: 0 0 66.666667%;\n  max-width: 66.666667%;\n}\n#iris-recommend-ui .iiris-col-9,\n#iris-recommend-ui .col-9 {\n  -ms-flex: 0 0 75%;\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n#iris-recommend-ui .iiris-col-10,\n#iris-recommend-ui .col-10 {\n  -ms-flex: 0 0 83.333333%;\n  flex: 0 0 83.333333%;\n  max-width: 83.333333%;\n}\n#iris-recommend-ui .iiris-col-11,\n#iris-recommend-ui .col-11 {\n  -ms-flex: 0 0 91.666667%;\n  flex: 0 0 91.666667%;\n  max-width: 91.666667%;\n}\n#iris-recommend-ui .iiris-col-12,\n#iris-recommend-ui .col-12 {\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n#iris-recommend-ui .order-first {\n  -ms-flex-order: -1;\n  order: -1;\n}\n#iris-recommend-ui .order-last {\n  -ms-flex-order: 13;\n  order: 13;\n}\n#iris-recommend-ui .order-0 {\n  -ms-flex-order: 0;\n  order: 0;\n}\n#iris-recommend-ui .order-1 {\n  -ms-flex-order: 1;\n  order: 1;\n}\n#iris-recommend-ui .order-2 {\n  -ms-flex-order: 2;\n  order: 2;\n}\n#iris-recommend-ui .order-3 {\n  -ms-flex-order: 3;\n  order: 3;\n}\n#iris-recommend-ui .order-4 {\n  -ms-flex-order: 4;\n  order: 4;\n}\n#iris-recommend-ui .order-5 {\n  -ms-flex-order: 5;\n  order: 5;\n}\n#iris-recommend-ui .order-6 {\n  -ms-flex-order: 6;\n  order: 6;\n}\n#iris-recommend-ui .order-7 {\n  -ms-flex-order: 7;\n  order: 7;\n}\n#iris-recommend-ui .order-8 {\n  -ms-flex-order: 8;\n  order: 8;\n}\n#iris-recommend-ui .order-9 {\n  -ms-flex-order: 9;\n  order: 9;\n}\n#iris-recommend-ui .order-10 {\n  -ms-flex-order: 10;\n  order: 10;\n}\n#iris-recommend-ui .order-11 {\n  -ms-flex-order: 11;\n  order: 11;\n}\n#iris-recommend-ui .order-12 {\n  -ms-flex-order: 12;\n  order: 12;\n}\n#iris-recommend-ui .offset-1 {\n  margin-left: 8.333333%;\n}\n#iris-recommend-ui .offset-2 {\n  margin-left: 16.666667%;\n}\n#iris-recommend-ui .offset-3 {\n  margin-left: 25%;\n}\n#iris-recommend-ui .offset-4 {\n  margin-left: 33.333333%;\n}\n#iris-recommend-ui .offset-5 {\n  margin-left: 41.666667%;\n}\n#iris-recommend-ui .offset-6 {\n  margin-left: 50%;\n}\n#iris-recommend-ui .offset-7 {\n  margin-left: 58.333333%;\n}\n#iris-recommend-ui .offset-8 {\n  margin-left: 66.666667%;\n}\n#iris-recommend-ui .offset-9 {\n  margin-left: 75%;\n}\n#iris-recommend-ui .offset-10 {\n  margin-left: 83.333333%;\n}\n#iris-recommend-ui .offset-11 {\n  margin-left: 91.666667%;\n}\n@media (min-width: 576px) {\n  #iris-recommend-ui .iiris-col-sm,\n  #iris-recommend-ui .col-sm {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .row-iris-cols-sm-1 > * {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .row-iris-cols-sm-2 > * {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  #iris-recommend-ui .row-iris-cols-sm-3 > * {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  #iris-recommend-ui .row-iris-cols-sm-4 > * {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  #iris-recommend-ui .row-iris-cols-sm-5 > * {\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  #iris-recommend-ui .row-iris-cols-sm-6 > * {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-sm-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .order-sm-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n\n  #iris-recommend-ui .order-sm-last {\n    -ms-flex-order: 13;\n    order: 13;\n  }\n\n  #iris-recommend-ui .order-sm-0 {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  #iris-recommend-ui .order-sm-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  #iris-recommend-ui .order-sm-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  #iris-recommend-ui .order-sm-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  #iris-recommend-ui .order-sm-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  #iris-recommend-ui .order-sm-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  #iris-recommend-ui .order-sm-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  #iris-recommend-ui .order-sm-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  #iris-recommend-ui .order-sm-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  #iris-recommend-ui .order-sm-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  #iris-recommend-ui .order-sm-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  #iris-recommend-ui .order-sm-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  #iris-recommend-ui .order-sm-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n\n  #iris-recommend-ui .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  #iris-recommend-ui .offset-sm-1 {\n    margin-left: 8.333333%;\n  }\n\n  #iris-recommend-ui .offset-sm-2 {\n    margin-left: 16.666667%;\n  }\n\n  #iris-recommend-ui .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  #iris-recommend-ui .offset-sm-4 {\n    margin-left: 33.333333%;\n  }\n\n  #iris-recommend-ui .offset-sm-5 {\n    margin-left: 41.666667%;\n  }\n\n  #iris-recommend-ui .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  #iris-recommend-ui .offset-sm-7 {\n    margin-left: 58.333333%;\n  }\n\n  #iris-recommend-ui .offset-sm-8 {\n    margin-left: 66.666667%;\n  }\n\n  #iris-recommend-ui .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  #iris-recommend-ui .offset-sm-10 {\n    margin-left: 83.333333%;\n  }\n\n  #iris-recommend-ui .offset-sm-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media (min-width: 768px) {\n  #iris-recommend-ui .iiris-col-md {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .row-cols-md-1 > * {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .row-cols-md-2 > * {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  #iris-recommend-ui .row-cols-md-3 > * {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  #iris-recommend-ui .row-cols-md-4 > * {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  #iris-recommend-ui .row-cols-md-5 > * {\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  #iris-recommend-ui .row-cols-md-6 > * {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-md-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .order-md-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n\n  #iris-recommend-ui .order-md-last {\n    -ms-flex-order: 13;\n    order: 13;\n  }\n\n  #iris-recommend-ui .order-md-0 {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  #iris-recommend-ui .order-md-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  #iris-recommend-ui .order-md-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  #iris-recommend-ui .order-md-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  #iris-recommend-ui .order-md-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  #iris-recommend-ui .order-md-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  #iris-recommend-ui .order-md-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  #iris-recommend-ui .order-md-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  #iris-recommend-ui .order-md-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  #iris-recommend-ui .order-md-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  #iris-recommend-ui .order-md-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  #iris-recommend-ui .order-md-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  #iris-recommend-ui .order-md-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n\n  #iris-recommend-ui .offset-md-0 {\n    margin-left: 0;\n  }\n\n  #iris-recommend-ui .offset-md-1 {\n    margin-left: 8.333333%;\n  }\n\n  #iris-recommend-ui .offset-md-2 {\n    margin-left: 16.666667%;\n  }\n\n  #iris-recommend-ui .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  #iris-recommend-ui .offset-md-4 {\n    margin-left: 33.333333%;\n  }\n\n  #iris-recommend-ui .offset-md-5 {\n    margin-left: 41.666667%;\n  }\n\n  #iris-recommend-ui .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  #iris-recommend-ui .offset-md-7 {\n    margin-left: 58.333333%;\n  }\n\n  #iris-recommend-ui .offset-md-8 {\n    margin-left: 66.666667%;\n  }\n\n  #iris-recommend-ui .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  #iris-recommend-ui .offset-md-10 {\n    margin-left: 83.333333%;\n  }\n\n  #iris-recommend-ui .offset-md-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media (min-width: 992px) {\n  #iris-recommend-ui .iiris-col-lg {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .row-cols-lg-1 > * {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .row-cols-lg-2 > * {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  #iris-recommend-ui .row-cols-lg-3 > * {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  #iris-recommend-ui .row-cols-lg-4 > * {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  #iris-recommend-ui .row-cols-lg-5 > * {\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  #iris-recommend-ui .row-cols-lg-6 > * {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-lg-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .order-lg-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n\n  #iris-recommend-ui .order-lg-last {\n    -ms-flex-order: 13;\n    order: 13;\n  }\n\n  #iris-recommend-ui .order-lg-0 {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  #iris-recommend-ui .order-lg-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  #iris-recommend-ui .order-lg-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  #iris-recommend-ui .order-lg-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  #iris-recommend-ui .order-lg-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  #iris-recommend-ui .order-lg-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  #iris-recommend-ui .order-lg-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  #iris-recommend-ui .order-lg-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  #iris-recommend-ui .order-lg-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  #iris-recommend-ui .order-lg-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  #iris-recommend-ui .order-lg-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  #iris-recommend-ui .order-lg-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  #iris-recommend-ui .order-lg-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n\n  #iris-recommend-ui .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  #iris-recommend-ui .offset-lg-1 {\n    margin-left: 8.333333%;\n  }\n\n  #iris-recommend-ui .offset-lg-2 {\n    margin-left: 16.666667%;\n  }\n\n  #iris-recommend-ui .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  #iris-recommend-ui .offset-lg-4 {\n    margin-left: 33.333333%;\n  }\n\n  #iris-recommend-ui .offset-lg-5 {\n    margin-left: 41.666667%;\n  }\n\n  #iris-recommend-ui .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  #iris-recommend-ui .offset-lg-7 {\n    margin-left: 58.333333%;\n  }\n\n  #iris-recommend-ui .offset-lg-8 {\n    margin-left: 66.666667%;\n  }\n\n  #iris-recommend-ui .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  #iris-recommend-ui .offset-lg-10 {\n    margin-left: 83.333333%;\n  }\n\n  #iris-recommend-ui .offset-lg-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media (min-width: 1200px) {\n  #iris-recommend-ui .iiris-col-xl {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .row-cols-xl-1 > * {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .row-cols-xl-2 > * {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  #iris-recommend-ui .row-cols-xl-3 > * {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  #iris-recommend-ui .row-cols-xl-4 > * {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  #iris-recommend-ui .row-cols-xl-5 > * {\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  #iris-recommend-ui .row-cols-xl-6 > * {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n\n  #iris-recommend-ui .iiris-col-xl-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  #iris-recommend-ui .order-xl-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n}\n\n#iris-recommend-ui .iiris-row,\n#iris-recommend-ui .row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n#iris-recommend-ui button,\n#iris-recommend-ui input,\n#iris-recommend-ui optgroup,\n#iris-recommend-ui select,\n#iris-recommend-ui textarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n#iris-recommend-ui button,\n#iris-recommend-ui input {\n  overflow: visible;\n}\n\n#iris-recommend-ui button,\n#iris-recommend-ui select {\n  text-transform: none;\n}\n\n#iris-recommend-ui [role=\"button\"] {\n  cursor: pointer;\n}\n\n#iris-recommend-ui select {\n  word-wrap: normal;\n}\n#iris-recommend-ui select.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n#iris-recommend-ui select.form-control[multiple],\n#iris-recommend-ui select.form-control[size] {\n  height: auto;\n}\n\n#iris-recommend-ui textarea.form-control {\n  height: auto;\n}\n\n#iris-recommend-ui .form-check-input.is-valid ~ .form-check-label,\n#iris-recommend-ui .was-validated .form-check-input:valid ~ .form-check-label {\n  color: #28a745;\n}\n\n#iris-recommend-ui .form-check-input.is-valid ~ .valid-feedback,\n#iris-recommend-ui .form-check-input.is-valid ~ .valid-tooltip,\n#iris-recommend-ui .was-validated .form-check-input:valid ~ .valid-feedback,\n#iris-recommend-ui .was-validated .form-check-input:valid ~ .valid-tooltip {\n  display: block;\n}\n\n#iris-recommend-ui .custom-control-input.is-valid ~ .custom-control-label,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:valid\n  ~ .custom-control-label {\n  color: #28a745;\n}\n\n#iris-recommend-ui\n  .custom-control-input.is-valid\n  ~ .custom-control-label::before,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:valid\n  ~ .custom-control-label::before {\n  border-color: #28a745;\n}\n\n#iris-recommend-ui\n  .custom-control-input.is-valid:checked\n  ~ .custom-control-label::before,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:valid:checked\n  ~ .custom-control-label::before {\n  border-color: #34ce57;\n  background-color: #34ce57;\n}\n\n#iris-recommend-ui\n  .custom-control-input.is-valid:focus\n  ~ .custom-control-label::before,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:valid:focus\n  ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n#iris-recommend-ui\n  .custom-control-input.is-valid:focus:not(:checked)\n  ~ .custom-control-label::before,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:valid:focus:not(:checked)\n  ~ .custom-control-label::before {\n  border-color: #28a745;\n}\n\n#iris-recommend-ui .custom-file-input.is-valid ~ .custom-file-label,\n#iris-recommend-ui\n  .was-validated\n  .custom-file-input:valid\n  ~ .custom-file-label {\n  border-color: #28a745;\n}\n\n#iris-recommend-ui .custom-file-input.is-valid:focus ~ .custom-file-label,\n#iris-recommend-ui\n  .was-validated\n  .custom-file-input:valid:focus\n  ~ .custom-file-label {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n#iris-recommend-ui .invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #dc3545;\n}\n\n#iris-recommend-ui .invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(220, 53, 69, 0.9);\n  border-radius: 0.25rem;\n}\n\n#iris-recommend-ui .is-invalid ~ .invalid-feedback,\n#iris-recommend-ui .is-invalid ~ .invalid-tooltip,\n#iris-recommend-ui .was-validated :invalid ~ .invalid-feedback,\n#iris-recommend-ui .was-validated :invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n#iris-recommend-ui .form-control.is-invalid,\n#iris-recommend-ui .was-validated .form-control:invalid {\n  border-color: #dc3545;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n#iris-recommend-ui .form-control.is-invalid:focus,\n#iris-recommend-ui .was-validated .form-control:invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n#iris-recommend-ui .was-validated textarea.form-control:invalid,\n#iris-recommend-ui textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right\n    calc(0.375em + 0.1875rem);\n}\n#iris-recommend-ui .iiris-custom-select.is-invalid,\n#iris-recommend-ui .was-validated .iiris-custom-select:invalid {\n  border-color: #dc3545;\n  padding-right: calc(0.75em + 2.3125rem);\n  background:\n    url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\")\n      no-repeat right 0.75rem center/8px 10px,\n    url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\")\n      #fff no-repeat center right 1.75rem / calc(0.75em + 0.375rem)\n      calc(0.75em + 0.375rem);\n}\n#iris-recommend-ui .iiris-custom-select.is-invalid:focus,\n#iris-recommend-ui .was-validated .iiris-custom-select:invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n#iris-recommend-ui .form-check-input.is-invalid ~ .form-check-label,\n#iris-recommend-ui\n  .was-validated\n  .form-check-input:invalid\n  ~ .form-check-label {\n  color: #dc3545;\n}\n#iris-recommend-ui .form-check-input.is-invalid ~ .invalid-feedback,\n#iris-recommend-ui .form-check-input.is-invalid ~ .invalid-tooltip,\n#iris-recommend-ui .was-validated .form-check-input:invalid ~ .invalid-feedback,\n#iris-recommend-ui .was-validated .form-check-input:invalid ~ .invalid-tooltip {\n  display: block;\n}\n#iris-recommend-ui .custom-control-input.is-invalid ~ .custom-control-label,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:invalid\n  ~ .custom-control-label {\n  color: #dc3545;\n}\n#iris-recommend-ui\n  .custom-control-input.is-invalid\n  ~ .custom-control-label::before,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:invalid\n  ~ .custom-control-label::before {\n  border-color: #dc3545;\n}\n#iris-recommend-ui\n  .custom-control-input.is-invalid:checked\n  ~ .custom-control-label::before,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:invalid:checked\n  ~ .custom-control-label::before {\n  border-color: #e4606d;\n  background-color: #e4606d;\n}\n#iris-recommend-ui\n  .custom-control-input.is-invalid:focus\n  ~ .custom-control-label::before,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:invalid:focus\n  ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n#iris-recommend-ui\n  .custom-control-input.is-invalid:focus:not(:checked)\n  ~ .custom-control-label::before,\n#iris-recommend-ui\n  .was-validated\n  .custom-control-input:invalid:focus:not(:checked)\n  ~ .custom-control-label::before {\n  border-color: #dc3545;\n}\n#iris-recommend-ui .custom-file-input.is-invalid ~ .custom-file-label,\n#iris-recommend-ui\n  .was-validated\n  .custom-file-input:invalid\n  ~ .custom-file-label {\n  border-color: #dc3545;\n}\n#iris-recommend-ui .custom-file-input.is-invalid:focus ~ .custom-file-label,\n#iris-recommend-ui\n  .was-validated\n  .custom-file-input:invalid:focus\n  ~ .custom-file-label {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n#iris-recommend-ui .custom-file,\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group > .form-control,\n#iris-recommend-ui .iiris-input-group > .form-control-plaintext {\n  position: relative;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  margin-bottom: 0;\n}\n#iris-recommend-ui .iiris-input-group > .custom-file + .custom-file,\n#iris-recommend-ui .iiris-input-group > .custom-file + .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group > .custom-file + .form-control,\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select + .custom-file,\n#iris-recommend-ui\n  .iiris-input-group\n  > .iiris-custom-select\n  + .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select + .form-control,\n#iris-recommend-ui .iiris-input-group > .form-control + .custom-file,\n#iris-recommend-ui .iiris-input-group > .form-control + .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group > .form-control + .form-control,\n#iris-recommend-ui .iiris-input-group > .form-control-plaintext + .custom-file,\n#iris-recommend-ui\n  .iiris-input-group\n  > .form-control-plaintext\n  + .iiris-custom-select,\n#iris-recommend-ui\n  .iiris-input-group\n  > .form-control-plaintext\n  + .form-control {\n  margin-left: -1px;\n}\n#iris-recommend-ui\n  .iiris-input-group\n  > .custom-file\n  .custom-file-input:focus\n  ~ .custom-file-label,\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select:focus,\n#iris-recommend-ui .iiris-input-group > .form-control:focus {\n  z-index: 3;\n}\n#iris-recommend-ui .iiris-input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select:not(:last-child),\n#iris-recommend-ui .iiris-input-group > .form-control:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n#iris-recommend-ui .iiris-input-group > .iiris-custom-select:not(:first-child),\n#iris-recommend-ui .iiris-input-group > .form-control:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n#iris-recommend-ui .iiris-input-group > .custom-file {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n#iris-recommend-ui\n  .iiris-input-group\n  > .custom-file:not(:last-child)\n  .custom-file-label,\n#iris-recommend-ui\n  .iiris-input-group\n  > .custom-file:not(:last-child)\n  .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n#iris-recommend-ui\n  .iiris-input-group\n  > .custom-file:not(:first-child)\n  .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n#iris-recommend-ui .iiris-input-group-append,\n#iris-recommend-ui .iiris-input-group-prepend {\n  display: -ms-flexbox;\n  display: flex;\n}\n#iris-recommend-ui .iiris-input-group-append .btn,\n#iris-recommend-ui .iiris-input-group-prepend .btn {\n  position: relative;\n  z-index: 2;\n}\n#iris-recommend-ui .iiris-input-group-append .btn:focus,\n#iris-recommend-ui .iiris-input-group-prepend .btn:focus {\n  z-index: 3;\n}\n#iris-recommend-ui .iiris-input-group-append .btn + .btn,\n#iris-recommend-ui .iiris-input-group-append .btn + .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-append .iiris-input-group-text + .btn,\n#iris-recommend-ui\n  .iiris-input-group-append\n  .iiris-input-group-text\n  + .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-prepend .btn + .btn,\n#iris-recommend-ui .iiris-input-group-prepend .btn + .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-prepend .iiris-input-group-text + .btn,\n#iris-recommend-ui\n  .iiris-input-group-prepend\n  .iiris-input-group-text\n  + .iiris-input-group-text {\n  margin-left: -1px;\n}\n#iris-recommend-ui .iiris-input-group-prepend {\n  margin-right: -1px;\n}\n#iris-recommend-ui .iiris-input-group-append {\n  margin-left: -1px;\n}\n#iris-recommend-ui .iiris-input-group-text {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n#iris-recommend-ui .iiris-input-group-text input[type=\"checkbox\"],\n#iris-recommend-ui .iiris-input-group-text input[type=\"radio\"] {\n  margin-top: 0;\n}\n#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group-lg > .form-control:not(textarea) {\n  height: calc(1.5em + 1rem + 2px);\n}\n#iris-recommend-ui .iiris-input-group-lg > .iiris-custom-select,\n#iris-recommend-ui .iiris-input-group-lg > .form-control,\n#iris-recommend-ui .iiris-input-group-lg > .iiris-input-group-append > .btn,\n#iris-recommend-ui\n  .iiris-input-group-lg\n  > .iiris-input-group-append\n  > .iiris-input-group-text,\n#iris-recommend-ui .iiris-input-group-lg > .iiris-input-group-prepend > .btn,\n#iris-recommend-ui\n  .iiris-input-group-lg\n  > .iiris-input-group-prepend\n  > .iiris-input-group-text {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n#iris-recommend-ui .iiris-custom-select-sm > .iiris-custom-select,\n#iris-recommend-ui .iiris-custom-select-sm > .form-control:not(textarea) {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n#iris-recommend-ui .iiris-custom-select-sm > .iiris-custom-select,\n#iris-recommend-ui .iiris-custom-select-sm > .form-control,\n#iris-recommend-ui .iiris-custom-select-sm > .iiris-custom-select-append > .btn,\n#iris-recommend-ui\n  .iiris-custom-select-sm\n  > .iiris-custom-select-append\n  > .iiris-custom-select-text,\n#iris-recommend-ui\n  .iiris-custom-select-sm\n  > .iiris-custom-select-prepend\n  > .btn,\n#iris-recommend-ui\n  .iiris-custom-select-sm\n  > .iiris-custom-select-prepend\n  > .iiris-custom-select-text {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n#iris-recommend-ui .iiris-custom-select-lg > .iiris-custom-select,\n#iris-recommend-ui .iiris-custom-select-sm > .iiris-custom-select {\n  padding-right: 1.75rem;\n}\n#iris-recommend-ui .iiris-custom-select.is-valid:focus,\n#iris-recommend-ui .was-validated .iiris-custom-select:valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n#iris-recommend-ui .iiris-mb-3,\n#iris-recommend-ui .iiris-my-3 {\n  margin-bottom: 1rem !important;\n}\n#iris-recommend-ui .iiris-mb-4 {\n  margin-bottom: 4rem !important;\n}\n#iris-recommend-ui .iiris-card,\n#iris-recommend-ui .card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n#iris-recommend-ui .iiris-card,\n#iris-recommend-ui .card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n#iris-recommend-ui .iiris-card,\n#iris-recommend-ui .card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n#iris-recommend-ui .iiris-card,\n#iris-recommend-ui .card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n#iris-recommend-ui .iiris-card-body {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.25rem;\n}\n#iris-recommend-ui .iiris-card-title {\n  margin-bottom: 0.75rem;\n}\n#iris-recommend-ui .iiris-card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0;\n}\n#iris-recommend-ui .iiris-card-text:last-child {\n  margin-bottom: 0;\n}\n#iris-recommend-ui .iiris-card-link:hover {\n  text-decoration: none;\n}\n#iris-recommend-ui .iiris-card-link + .iiris-card-link {\n  margin-left: 1.25rem;\n}\n#iris-recommend-ui .iiris-card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n#iris-recommend-ui .iiris-card-header:first-child {\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n#iris-recommend-ui\n  .iiris-card-header\n  + .list-group\n  .list-group-item:first-child {\n  border-top: 0;\n}\n#iris-recommend-ui .iiris-card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\n}\n#iris-recommend-ui .iiris-card-footer:last-child {\n  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n#iris-recommend-ui .iiris-card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0;\n}\n#iris-recommend-ui .iiris-card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem;\n}\n#iris-recommend-ui .iiris-card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n}\n#iris-recommend-ui .iiris-card-img,\n#iris-recommend-ui .iiris-card-img-bottom,\n#iris-recommend-ui .iiris-card-img-top {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 100%;\n}\n#iris-recommend-ui .iiris-card-img,\n#iris-recommend-ui .iiris-card-img-top {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n#iris-recommend-ui .iiris-card-img,\n#iris-recommend-ui .iiris-card-img-bottom {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n#iris-recommend-ui .iiris-card-deck .iiris-card,\n#iris-recommend-ui .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  #iris-recommend-ui .iiris-card-deck {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n  #iris-recommend-ui .iiris-card-deck .iiris-card,\n  #iris-recommend-ui .card {\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n#iris-recommend-ui .iiris-card-group > .iiris-card,\n#iris-recommend-ui .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  #iris-recommend-ui .iiris-card-group {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n    flex-flow: row wrap;\n  }\n  #iris-recommend-ui .iiris-card-group > .iiris-card,\n  #iris-recommend-ui .card {\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  #iris-recommend-ui .iiris-card-group > .iiris-card + .iiris-card,\n  #iris-recommend-ui .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  #iris-recommend-ui .iiris-card-group > .iiris-card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  #iris-recommend-ui\n    .iiris-card-group\n    > .iiris-card:not(:last-child)\n    .iiris-card-header,\n  #iris-recommend-ui\n    .iiris-card-group\n    > .iiris-card:not(:last-child)\n    .iiris-card-img-top {\n    border-top-right-radius: 0;\n  }\n  #iris-recommend-ui\n    .iiris-card-group\n    > .iiris-card:not(:last-child)\n    .iiris-card-footer,\n  #iris-recommend-ui\n    .iiris-card-group\n    > .iiris-card:not(:last-child)\n    .iiris-card-img-bottom {\n    border-bottom-right-radius: 0;\n  }\n  #iris-recommend-ui .iiris-card-group > .iiris-card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  #iris-recommend-ui\n    .iiris-card-group\n    > .iiris-card:not(:first-child)\n    .iiris-card-header,\n  #iris-recommend-ui\n    .iiris-card-group\n    > .iiris-card:not(:first-child)\n    .iiris-card-img-top {\n    border-top-left-radius: 0;\n  }\n  #iris-recommend-ui\n    .iiris-card-group\n    > .iiris-card:not(:first-child)\n    .iiris-card-footer,\n  #iris-recommend-ui\n    .iiris-card-group\n    > .iiris-card:not(:first-child)\n    .iiris-card-img-bottom {\n    border-bottom-left-radius: 0;\n  }\n}\n\n#iris-recommend-ui .iiris-card-columns .iiris-card,\n#iris-recommend-ui .card {\n  margin-bottom: 0.75rem;\n}\n\n@media (min-width: 576px) {\n  #iris-recommend-ui .iiris-card-columns {\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    -webkit-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n  #iris-recommend-ui .iiris-card-columns .iiris-card,\n  #iris-recommend-ui .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n#iris-recommend-ui .iiris-accordion > .iiris-card:not(:last-of-type) {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n#iris-recommend-ui .iiris-accordion > .iiris-card:not(:first-of-type) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n#iris-recommend-ui .iiris-accordion > .iiris-card > .iiris-card-header {\n  border-radius: 0;\n  margin-bottom: -1px;\n}\n#iris-recommend-ui .iiris-text-muted {\n  color: #6c757d !important;\n}\n#iris-recommend-ui label {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n#iris-recommend-ui .iiris-custom-select.is-valid:focus,\n#iris-recommend-ui .was-validated .iiris-custom-select:valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n#iris-recommend-ui .iiris-custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  background: #fff\n    url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\")\n    no-repeat right 0.75rem center/8px 10px;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n#iris-recommend-ui .iiris-custom-select:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n#iris-recommend-ui .iiris-custom-select:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n#iris-recommend-ui .iiris-custom-select[multiple],\n#iris-recommend-ui .iiris-custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n#iris-recommend-ui .iiris-custom-select:disabled {\n  color: #6c757d;\n  background-color: #e9ecef;\n}\n#iris-recommend-ui .iiris-custom-select::-ms-expand {\n  display: none;\n}\n#iris-recommend-ui .iiris-custom-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057;\n}\n#iris-recommend-ui .iiris-custom-select-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n}\n#iris-recommend-ui .iiris-custom-select-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n}\n#iris-recommend-ui .custom-control-label::before,\n#iris-recommend-ui .custom-file-label,\n#iris-recommend-ui .iiris-custom-select {\n  transition:\n    background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  #iris-recommend-ui .custom-control-label::before,\n  #iris-recommend-ui .custom-file-label,\n  #iris-recommend-ui .iiris-custom-select {\n    transition: none;\n  }\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n#iris-recommend-ui .carousel {\n  position: relative;\n}\n\n#iris-recommend-ui .carousel.pointer-event {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n\n#iris-recommend-ui .carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  z-index: 2;\n}\n\n#iris-recommend-ui .carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n#iris-recommend-ui .carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  margin-bottom: 20px;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  transition: -webkit-transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out;\n  transition:\n    transform 0.6s ease-in-out,\n    -webkit-transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  #iris-recommend-ui .carousel-item {\n    transition: none;\n  }\n}\n#iris-recommend-ui .carousel-item.active,\n#iris-recommend-ui .carousel-item-next,\n#iris-recommend-ui .carousel-item-prev {\n  display: block;\n}\n#iris-recommend-ui .carousel-item-next:not(.carousel-item-left),\n#iris-recommend-ui .active.carousel-item-right {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n#iris-recommend-ui .carousel-item-prev:not(.carousel-item-right),\n#iris-recommend-ui .active.carousel-item-left {\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%);\n}\n#iris-recommend-ui .carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  -webkit-transform: none;\n  transform: none;\n}\n#iris-recommend-ui .carousel-fade .carousel-item.active,\n#iris-recommend-ui .carousel-fade .carousel-item-next.carousel-item-left,\n#iris-recommend-ui .carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1;\n}\n#iris-recommend-ui .carousel-fade .active.carousel-item-left,\n#iris-recommend-ui .carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: 0s 0.6s opacity;\n}\n@media (prefers-reduced-motion: reduce) {\n  #iris-recommend-ui .carousel-fade .active.carousel-item-left,\n  #iris-recommend-ui .carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n#iris-recommend-ui .carousel-control-prev,\n#iris-recommend-ui .carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  #iris-recommend-ui .carousel-control-prev,\n  #iris-recommend-ui .carousel-control-next {\n    transition: none;\n  }\n}\n#iris-recommend-ui .carousel-control-prev:hover,\n.carousel-control-prev:focus,\n#iris-recommend-ui .carousel-control-next:hover,\n#iris-recommend-ui .carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n#iris-recommend-ui .carousel-control-prev {\n  left: 0;\n  margin-left: -10%;\n}\n#iris-recommend-ui .carousel-control-next {\n  right: 0;\n  margin-right: -10%;\n}\n#iris-recommend-ui .carousel-control-prev-icon,\n#iris-recommend-ui .carousel-control-next-icon {\n  width: 35px;\n  height: 35px;\n  background-color: #fffcfc;\n  border-radius: 32px;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 15px rgb(36 38 38 / 36%);\n  position: absolute;\n  z-index: 2;\n  display: inline-block;\n  background-position-x: center;\n  background-position-y: center;\n  background-size: 60% 100%;\n  background-attachment: initial;\n  background-origin: initial;\n  background-clip: initial;\n  background-repeat: no-repeat;\n}\n#iris-recommend-ui .carousel-control-prev-icon:hover,\n#iris-recommend-ui .carousel-control-next-icon:hover,\n#iris-recommend-ui .rec-arrow-left:hover,\n#iris-recommend-ui .rec-arrow-right:hover,\n#iris-recommend-ui .rec-arrow-down:hover,\n.rec-arrow-up:hover,\n#iris-recommend-ui .rec-arrow-left:focus,\n#iris-recommend-ui .rec-arrow-right:focus,\n#iris-recommend-ui .rec-arrow-down:focus,\n.rec-arrow-up:focus {\n  box-shadow: 0 3px 20px rgb(36 38 38 / 63%) !important;\n  background-color: inherit !important;\n}\n#iris-recommend-ui .rec-arrow-left:disabled,\n.rec-arrow-right:disabled,\n.rec-arrow-down:disabled,\n.rec-arrow-up:disabled {\n  opacity: 0.5;\n}\n#iris-recommend-ui .carousel-control-prev-icon,\n.rec-arrow-left {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\");\n}\n#iris-recommend-ui .carousel-control-next-icon,\n.rec-arrow-right {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\");\n}\n#iris-recommend-ui .rec-arrow-down {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\");\n  transform: rotate(268deg) !important;\n  -webkit-transform: rotate(268deg) !important;\n  -moz-transform: rotate(268deg) !important;\n  -o-transform: rotate(268deg) !important;\n  -ms-transform: rotate(268deg) !important;\n  bottom: -30px !important;\n  left: calc(50% + -14px) !important;\n  position: absolute;\n}\n#iris-recommend-ui .rec-arrow-up {\n  position: absolute;\n  transform: rotate(90deg);\n  top: -60px !important;\n  left: calc(50% + -14px) !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\");\n}\n#iris-recommend-ui .carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n#iris-recommend-ui .carousel-indicators li {\n  box-sizing: content-box;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  #iris-recommend-ui .carousel-indicators li {\n    transition: none;\n  }\n}\n#iris-recommend-ui .carousel-indicators .active {\n  opacity: 1;\n}\n#iris-recommend-ui .carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n#iris-recommend-ui .visually-hidden {\n  visibility: hidden;\n}\n#iris-recommend-ui img {\n  vertical-align: middle;\n  border-style: none;\n}\n#iris-recommend-ui .popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n}\n#iris-recommend-ui .popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 0.3rem;\n}\n#iris-recommend-ui .popover .arrow::before,\n.popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n#iris-recommend-ui .bs-popover-top,\n.bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem;\n}\n#iris-recommend-ui .bs-popover-top > .arrow,\n.bs-popover-auto[x-placement^=\"top\"] > .arrow {\n  bottom: calc((0.5rem + 1px) * -1);\n}\n#iris-recommend-ui .bs-popover-top > .arrow::before,\n.bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n#iris-recommend-ui .bs-popover-top > .arrow::after,\n.bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n#iris-recommend-ui .bs-popover-right,\n.bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem;\n}\n#iris-recommend-ui .bs-popover-right > .arrow,\n.bs-popover-auto[x-placement^=\"right\"] > .arrow {\n  left: calc((0.5rem + 1px) * -1);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n#iris-recommend-ui .bs-popover-right > .arrow::before,\n.bs-popover-auto[x-placement^=\"right\"] > .arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n#iris-recommend-ui .bs-popover-right > .arrow::after,\n.bs-popover-auto[x-placement^=\"right\"] > .arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n#iris-recommend-ui .bs-popover-bottom,\n.bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem;\n}\n#iris-recommend-ui .bs-popover-bottom > .arrow,\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow {\n  top: calc((0.5rem + 1px) * -1);\n}\n#iris-recommend-ui .bs-popover-bottom > .arrow::before,\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n#iris-recommend-ui .bs-popover-bottom > .arrow::after,\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n#iris-recommend-ui .bs-popover-bottom .popover-header::before,\n.bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #f7f7f7;\n}\n#iris-recommend-ui .bs-popover-left,\n.bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem;\n}\n#iris-recommend-ui .bs-popover-left > .arrow,\n.bs-popover-auto[x-placement^=\"left\"] > .arrow {\n  right: calc((0.5rem + 1px) * -1);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n#iris-recommend-ui .bs-popover-left > .arrow::before,\n.bs-popover-auto[x-placement^=\"left\"] > .arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n#iris-recommend-ui .bs-popover-left > .arrow::after,\n.bs-popover-auto[x-placement^=\"left\"] > .arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n#iris-recommend-ui .popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n#iris-recommend-ui .popover-header:empty {\n  display: none;\n}\n#iris-recommend-ui .popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #212529;\n}\n#iris-recommend-ui .tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n#iris-recommend-ui .tooltip.show {\n  opacity: 0.9;\n}\n#iris-recommend-ui .tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n#iris-recommend-ui .tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n#iris-recommend-ui .bs-tooltip-top,\n.bs-tooltip-auto[x-placement^=\"top\"] {\n  padding: 0.4rem 0;\n}\n#iris-recommend-ui .bs-tooltip-top .arrow,\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n  bottom: 0;\n}\n#iris-recommend-ui .bs-tooltip-top .arrow::before,\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n#iris-recommend-ui .bs-tooltip-right,\n.bs-tooltip-auto[x-placement^=\"right\"] {\n  padding: 0 0.4rem;\n}\n#iris-recommend-ui .bs-tooltip-right .arrow,\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n#iris-recommend-ui .bs-tooltip-right .arrow::before,\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n#iris-recommend-ui .bs-tooltip-bottom,\n.bs-tooltip-auto[x-placement^=\"bottom\"] {\n  padding: 0.4rem 0;\n}\n#iris-recommend-ui .bs-tooltip-bottom .arrow,\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n  top: 0;\n}\n#iris-recommend-ui .bs-tooltip-bottom .arrow::before,\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n#iris-recommend-ui .bs-tooltip-left,\n.bs-tooltip-auto[x-placement^=\"left\"] {\n  padding: 0 0.4rem;\n}\n#iris-recommend-ui .bs-tooltip-left .arrow,\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n#iris-recommend-ui .bs-tooltip-left .arrow::before,\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n#iris-recommend-ui .tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem;\n}\n#iris-recommend-ui .rec-arrow-left,\n#iris-recommend-ui .rec-arrow-right,\n#iris-recommend-ui .rec-arrow-down,\n#iris-recommend-ui .rec-arrow-up {\n  width: 35px !important;\n  height: 35px !important;\n  line-height: 0px !important;\n  min-width: 35px !important;\n  color: rgb(103 58 183 / 0%) !important;\n  background-position-x: center;\n  background-position-y: center;\n  background-size: 60% 100%;\n  background-attachment: initial;\n  background-origin: initial;\n  background-clip: initial;\n  background-repeat: no-repeat;\n  box-shadow: 0 2px 15px rgb(36 38 38 / 36%) !important;\n}\n#iris-recommend-ui .rec-arrow-left {\n  position: absolute !important;\n  left: -3% !important;\n}\n#iris-recommend-ui .rec-arrow-right {\n  position: absolute !important;\n  right: -3% !important;\n}\n#iris-recommend-ui .text-left.disabled,\n#iris-recommend-ui .text-right.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n#iris-recommend-ui .rec-item-wrapper {\n  height: 100% !important;\n  /* box-sizing: unset !important; */\n}\n#iris-recommend-ui .one-by-one {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n#iris-recommend-ui .position-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n#iris-recommend-ui .scroll-top-bottom .carousel-control-prev {\n  position: absolute !important;\n  left: 53% !important;\n  top: -60px !important;\n}\n#iris-recommend-ui\n  .scroll-top-bottom\n  .carousel-control-prev\n  .carousel-control-prev-icon {\n  top: 0 !important;\n  transform: rotate(90deg) !important;\n}\n#iris-recommend-ui .scroll-top-bottom .carousel-control-next {\n  position: absolute !important;\n  right: 53% !important;\n  bottom: -20px !important;\n}\n#iris-recommend-ui\n  .scroll-top-bottom\n  .carousel-control-next\n  .carousel-control-next-icon {\n  bottom: 0 !important;\n  transform: rotate(90deg) !important;\n}\n#iris-recommend-ui .iiris-disable_center_buttons .rec-arrow-up,\n#iris-recommend-ui .iiris-disable_center_buttons .rec-arrow-down,\n#iris-recommend-ui .iiris-disable_center_buttons .rec-arrow-left,\n#iris-recommend-ui .iiris-disable_center_buttons .rec-arrow-right {\n  visibility: hidden;\n}\n\n.iiris-people-type .one-by-one,\n.iiris-people-type .iiris-carousel-container-items {\n  padding: 1px;\n}\n\n.iiris-people-type .one-by-one .iiris-col-sm,\n.iiris-people-type .iiris-carousel-container-items {\n  padding: 5px !important;\n}\n\n.iiris-people-type .iiris-card {\n  box-shadow: 0px 1px 5px 1px #0202021f;\n  border-radius: 0.5rem !important;\n}\n\n.iris-close-btn {\n  position: absolute;\n  right: 0;\n  margin: 4px;\n  z-index: 10;\n  margin-left: -1rem;\n  width: 1.4rem;\n  height: 1.4rem;\n  cursor: pointer;\n  border-radius: 50%;\n  border: 0.2rem solid;\n}\n\n.a-none {\n  color: inherit !important;\n  text-decoration: none !important;\n  height: 100%;\n}\n\n.iiris-popup-overlay {\n  background: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 100%;\n  z-index: 100000;\n}\n\n.iiris-popup-footer {\n  text-align: center;\n  margin: 8px 0;\n}\n\n.iiris-popup-body img {\n  width: 100%;\n  height: 100%;\n}\n\n.iiris-popup-body a {\n  width: 100%;\n}\n\n.content-heading {\n  font-weight: 600;\n  line-height: 1.5em;\n}\n\n.content-description {\n  font-weight: 400;\n  line-height: 1.5em;\n}\n\n.video-tag {\n  padding: 0.2rem;\n  border: 1px solid black;\n  margin: 4px;\n  border-radius: 4rem;\n  font-weight: 500;\n  font-size: 14px;\n  transition-duration: 0.3s;\n}\n\n.video-tag:hover {\n  color: white;\n  background: #1d2d35;\n  border-color: #1d2d35;\n}\n\n.video-col-container {\n  border: none !important;\n  border-radius: 0 !important;\n}\n\n.video-img-container {\n  background: none !important;\n}\n\n.grid-video-vertical .grid-vertical-content {\n  padding: 1rem 0 0 1rem;\n}\n\n.hover-underline:hover {\n  text-decoration: underline;\n}\n\n.iiris-video-type {\n  padding: 25px 0 0 0;\n}\n\n.grid-video-vertical:hover .play-button {\n  display: block;\n  opacity: 1;\n}\n\n.grid-video-vertical:hover .play-button img {\n  width: 50px;\n  height: 50px;\n}\n\n.grid-video-vertical:hover .video-insights {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 2rem;\n  padding: 2px;\n  background: white;\n  opacity: 1;\n}\n\n.grid-video-vertical:hover .pointer {\n  cursor: pointer;\n}\n\n.grid-video-vertical:hover .video-img-container {\n  opacity: 0.7;\n  position: relative;\n}\n\n.recommended-products ol li {\n  list-style-type: decimal !important;\n}\n\n.lazy-load-image-background.lazy-load-image-loaded {\n  width: 100%;\n}\n\n.no-image {\n  color: #c82333;\n}\n\n.iiris-popup-body {\n  overflow: hidden;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n}\n\n.html-body {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
